<template>
  <div>
    <h1 class="system_content_title">环保信用评价审核</h1>
    <div class="system_content_panels">
      <div class="systemPanel" style="position: relative; padding-bottom: 40px">
        <el-tabs v-model="activeName11" @tab-click="handleClick" style="width: 100%">
          <el-tab-pane label="当前审核" name="first">
            <el-row>
              <el-col :span="11" style="overflow: scroll; overflow-x: hidden; height: 790px">
                <el-collapse accordion width="100%">
                  <el-collapse-item name="promiseLetter">
                    <template #title>
                      <span>环境信用评价承诺书【必填】</span>
                    </template>
                    <p>请下载模板填写后上传承诺书</p>
                    <a href="http://221.10.90.140:8085/%E8%B4%B5%E5%B7%9E%E7%9C%81%E9%87%8D%E7%82%B9%E6%8E%92%E6%B1%A1%E5%8D%95%E4%BD%8D%E5%8F%82%E5%8A%A0%E7%8E%AF%E5%A2%83%E4%BF%A1%E7%94%A8%E8%AF%84%E4%BB%B7%E5%B7%A5%E4%BD%9C%E6%89%BF%E8%AF%BA%E4%B9%A6.pdf"
                      download="环境信用评价承诺书（模板）" target="blank">
                      模板下载（右键另存为）
                    </a>
                    <!-- <el-button @click="downloadPromiseLetter">downloadPromiseLetter</el-button> -->
                    <p class="fileText"></p>
                    <label>附件: </label>
                    <span style="color: blue; cursor: pointer" @click="checkFile(reviewSubmitDatas.promiseLetter)"
                      v-if="reviewSubmitDatas.promiseLetter">{{ getFileName(reviewSubmitDatas.promiseLetter) }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="promiseLetter" filePathKey="fileObj"
                      senum="2" value="" />
                  </el-collapse-item>
                  <el-collapse-item name="1">
                    <template #title>
                      <span>单位证明【企业自评与填报】</span>
                    </template>
                    <p>企业名称与营业执照不符情况说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.danWeiZhengMing.remark"></el-input>
                    <p></p>
                    <el-input style="width: 600px" type="text" maxlength="18" show-word-limit
                      v-model="reviewSubmitDatas.danWeiZhengMing.xinYongDaiMa" placeholder="单位统一社会信用代码">
                      <el-button #append @click="checkOrgCode">审核查看</el-button>
                    </el-input>
                    <p></p>
                    <el-select v-model="reviewSubmitDatas.danWeiZhengMing.companyStatus" class="m-2"
                      placeholder="选择单位状态" size="large">
                      <el-option v-for="item in optionsDatas.companyStatusOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                    </el-select>
                    <p></p>
                    <label>企业营业执照: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.danWeiZhengMing.yinYeZhiZhao
                          .filePath
                      )
                      " v-if="
                        reviewSubmitDatas.danWeiZhengMing.yinYeZhiZhao.filePath
                      ">{{
                        getFileName(
                          reviewSubmitDatas.danWeiZhengMing.yinYeZhiZhao
                            .filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="danWeiZhengMing" filePathKey="yinYeZhiZhao"
                      senum="1" value="" />
                    <br />
                    <p style="color: red">
                      *评价年度超过半年以上停产企业、超过半年以上未投产企业，佐证材料和营业执照一起合并上传
                    </p>
                  </el-collapse-item>

                  <el-collapse-item name="4">
                    <template #title>
                      <span>1、污染源自动在线监控【企业自评与填报】</span>
                    </template>
                    <span style="padding-right: 8px">企业说明</span>
                    <el-input style="width: 800px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem1.remark"></el-input>
                    <div v-if="reviewSubmitDatas.reviewItem1.radioSelect2 != 3">
                      <p></p>
                      <el-checkbox v-if="
                        !reviewSubmitDatas.reviewItem1.selectedOptions.includes(
                          '1'
                        )
                      " v-model="reviewSubmitDatas.reviewItem1.radioSelect1">按规定无需安装自动监控设备（6.5分）
                      </el-checkbox>
                      <p></p>

                      <el-checkbox-group v-if="!reviewSubmitDatas.reviewItem1.radioSelect1"
                        v-model="reviewSubmitDatas.reviewItem1.selectedOptions">
                        <el-checkbox label="1">按规定安装自动监控设备（2分）</el-checkbox>
                        <br />
                        <el-checkbox label="2">与生态环境部门联网并完成验收（2分）</el-checkbox>
                        <br />
                        <el-checkbox label="3">按照技术规范开展运行维护管理（1分）</el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <p></p>
                    <el-radio-group v-if="!reviewSubmitDatas.reviewItem1.radioSelect1"
                      v-model="reviewSubmitDatas.reviewItem1.radioSelect2" class="radioDiv">
                      <div>
                        <el-radio :label="1">自动监控设备年传输上报率≥90%（1.5分）</el-radio>
                      </div>
                      <div>
                        <el-radio :label="2">80≤自动监控设备年传输上报率＜90%（1分）</el-radio>
                      </div>

                      <div>
                        <el-radio :label="3">按规定应安装而未安装自动监控设备或在
                          线监测数据弄虚作假（0分）</el-radio>
                      </div>
                    </el-radio-group>
                    <p class="fileText"></p>
                    <div v-if="
                      !reviewSubmitDatas.reviewItem1.selectedOptions.includes(
                        '1'
                      ) && reviewSubmitDatas.reviewItem1.radioSelect1
                    ">
                      <label>附件1（情况说明）: </label>
                      <span style="color: blue; cursor: pointer" @click="
                        checkFile(
                          reviewSubmitDatas.reviewItem1.fileObj1.filePath
                        )
                        " v-if="reviewSubmitDatas.reviewItem1.fileObj1.filePath">{{
                          getFileName(
                            reviewSubmitDatas.reviewItem1.fileObj1.filePath
                          )
                        }}</span>
                      <input v-else type="file" accept=".pdf,image/*" objName="reviewItem1" filePathKey="fileObj1"
                        senum="2" value="" />

                      <p></p>
                    </div>
                    <p class="fileText"></p>
                    <div v-if="!reviewSubmitDatas.reviewItem1.radioSelect1">
                      <label>附件2（设备型号、安装时间等）: </label>
                      <span style="color: blue; cursor: pointer" @click="
                        checkFile(
                          reviewSubmitDatas.reviewItem1.fileObj2.filePath
                        )
                        " v-if="reviewSubmitDatas.reviewItem1.fileObj2.filePath">{{
                          getFileName(
                            reviewSubmitDatas.reviewItem1.fileObj2.filePath
                          )
                        }}</span>
                      <input v-else type="file" accept=".pdf,image/*" objName="reviewItem1" filePathKey="fileObj2"
                        senum="2" value="" />

                      <p class="fileText"></p>
                      <label>附件3（验收和联网）: </label>
                      <span style="color: blue; cursor: pointer" @click="
                        checkFile(
                          reviewSubmitDatas.reviewItem1.fileObj3.filePath
                        )
                        " v-if="reviewSubmitDatas.reviewItem1.fileObj3.filePath">{{
                          getFileName(
                            reviewSubmitDatas.reviewItem1.fileObj3.filePath
                          )
                        }}</span>
                      <input v-else type="file" accept=".pdf,image/*" objName="reviewItem1" filePathKey="fileObj3"
                        senum="2" value="" />

                      <p class="fileText"></p>
                      <label>附件4（运行和维护）: </label>
                      <span style="color: blue; cursor: pointer" @click="
                        checkFile(
                          reviewSubmitDatas.reviewItem1.fileObj4.filePath
                        )
                        " v-if="reviewSubmitDatas.reviewItem1.fileObj4.filePath">{{
                          getFileName(
                            reviewSubmitDatas.reviewItem1.fileObj4.filePath
                          )
                        }}</span>
                      <input v-else type="file" accept=".pdf,image/*" objName="reviewItem1" filePathKey="fileObj4"
                        senum="2" value="" />

                      <p class="fileText"></p>
                      <label>附件5（年传输上报率）: </label>
                      <span style="color: blue; cursor: pointer" @click="
                        checkFile(
                          reviewSubmitDatas.reviewItem1.fileObj5.filePath
                        )
                        " v-if="reviewSubmitDatas.reviewItem1.fileObj5.filePath">{{
                          getFileName(
                            reviewSubmitDatas.reviewItem1.fileObj5.filePath
                          )
                        }}</span>
                      <input v-else type="file" accept=".pdf,image/*" objName="reviewItem1" filePathKey="fileObj5"
                        senum="2" value="" />
                    </div>
                    <div class="button-container">
                      <p>
                        得分值：<span>{{
                          reviewSubmitDatas.reviewItem1.score
                        }}</span>
                      </p>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="2、污染源监督性监测【企业自评与填报】" name="5">
                    <template #title>
                      <span>2、污染源监督性监测【企业自评与填报】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem2.remark"></el-input>
                    <p></p>
                    <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem2.radioSelect">
                      <div>
                        <el-radio :label="1">按规定无需开展污染源监督性监测（5分）</el-radio>
                      </div>
                      <div>
                        <el-radio :label="2">全年达标率大于≥90%（5分）</el-radio>
                      </div>

                      <div><el-radio :label="3">75%≤全年达标率＜90%（3分）</el-radio></div>
                      <div><el-radio :label="4">65%≤全年达标率＜75%（2分）</el-radio></div>
                      <div><el-radio :label="5">50%≤全年达标率＜65%（1分）</el-radio></div>
                      <div><el-radio :label="6">全年达标率＜50%（0分）</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件（情况说明、监督性监测报告）: </label>

                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem2.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem2.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem2.fileObj.filePath
                        )
                      }}</span>

                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem2" filePathKey="fileObj"
                      senum="2" value="" />

                    <p></p>
                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem2.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="3、企业自行监测【企业自评与填报】" name="6">
                    <template #title>
                      <span>3、企业自行监测【企业自评与填报】</span>
                    </template>
                    <span style="padding-right: 6px">企业说明</span>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem3.remark"></el-input>
                    <p></p>
                    <el-checkbox v-model="reviewSubmitDatas.reviewItem3.radioSelect1">按规定无需开展企业自行监测(3分)
                    </el-checkbox>
                    <p></p>
                    <div v-if="!reviewSubmitDatas.reviewItem3.radioSelect1">
                      <el-radio-group v-model="reviewSubmitDatas.reviewItem3.radioSelect2" class="radioDiv">
                        <div> <el-radio :label="1">全面开展了自行监测，且自行监测完成率≥80%（1.5分）</el-radio></div>

                        <div> <el-radio :label="2">70%≤自行监测完成率＜80%（1分）</el-radio></div>
                        <div><el-radio :label="3">60%≤自行监测完成率＜70%（0.5分）</el-radio></div>
                        <div><el-radio :label="4">未按要求开展自行监测或自行监测完成率＜60%（0分）</el-radio></div>
                      </el-radio-group>
                      <p></p>
                      <el-radio-group v-model="reviewSubmitDatas.reviewItem3.radioSelect3" class="radioDiv">
                        <div> <el-radio :label="1">自行监测公布率≥90%（1.5分）</el-radio></div>
                        <div> <el-radio :label="2">80%≤自行监测公布率＜90%（1分）</el-radio></div>
                        <div><el-radio :label="3">70%≤自行监测公布率＜80%（0.5分）</el-radio></div>
                        <div> <el-radio :label="4">自行监测公布率＜70%（0分）</el-radio></div>
                      </el-radio-group>
                    </div>

                    <div v-if="reviewSubmitDatas.reviewItem3.radioSelect1">
                      <p class="fileText"></p>
                      <label>附件（无需开展企业自行检测）: </label>
                      <span style="color: blue; cursor: pointer" @click="
                        checkFile(
                          reviewSubmitDatas.reviewItem3.fileObj1.filePath
                        )
                        " v-if="reviewSubmitDatas.reviewItem3.fileObj1.filePath">{{
                          getFileName(
                            reviewSubmitDatas.reviewItem3.fileObj1.filePath
                          )
                        }}</span>
                      <input v-else type="file" accept=".pdf,image/*" objName="reviewItem3" filePathKey="fileObj1"
                        senum="2" value="" />

                      <p></p>
                    </div>

                    <div v-if="!reviewSubmitDatas.reviewItem3.radioSelect1">
                      <label>附件（自行检测完成率）: </label>
                      <span style="color: blue; cursor: pointer" @click="
                        checkFile(
                          reviewSubmitDatas.reviewItem3.fileObj2.filePath
                        )
                        " v-if="reviewSubmitDatas.reviewItem3.fileObj2.filePath">{{
                          getFileName(
                            reviewSubmitDatas.reviewItem3.fileObj2.filePath
                          )
                        }}</span>
                      <input v-else type="file" accept=".pdf,image/*" objName="reviewItem3" filePathKey="fileObj2"
                        senum="2" value="" />
                      <p class="fileText"></p>
                      <label>附件（自行检测公布率）: </label>
                      <span style="color: blue; cursor: pointer" @click="
                        checkFile(
                          reviewSubmitDatas.reviewItem3.fileObj3.filePath
                        )
                        " v-if="reviewSubmitDatas.reviewItem3.fileObj3.filePath">{{
                          getFileName(
                            reviewSubmitDatas.reviewItem3.fileObj3.filePath
                          )
                        }}</span>
                      <input v-else type="file" accept=".pdf,image/*" objName="reviewItem3" filePathKey="fileObj3"
                        senum="2" value="" />
                    </div>

                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem3.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="4、排污许可和总量控制【企业自评与填报】" name="7">
                    <template #title>
                      <span>4、排污许可和总量控制【企业自评与填报】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem4.remark"></el-input>
                    <p></p>
                    <el-checkbox v-model="reviewSubmitDatas.reviewItem4.radioSelect1">按规定无需办理排污许可证(4分)
                    </el-checkbox>
                    <p></p>
                    <div v-if="!reviewSubmitDatas.reviewItem4.radioSelect1">
                      <el-radio-group v-model="reviewSubmitDatas.reviewItem4.radioSelect2" class="radioDiv">
                        <div> <el-radio :label="1">依法办理排污许可证（2分）</el-radio></div>
                        <div> <el-radio :label="2">未依法办理排污许可证（0分）</el-radio></div>
                      </el-radio-group>
                      <p></p>
                      <el-radio-group v-model="reviewSubmitDatas.reviewItem4.radioSelect3" class="radioDiv">
                        <div><el-radio :label="1">企业排放总量全部符合许可量要求（2分）</el-radio></div>
                        <div><el-radio :label="2">企业排放总量任意一项不符合许可量要求（0分）</el-radio></div>
                      </el-radio-group>
                    </div>
                    <p></p>
                    <label>附件（情况说明或排污许可证）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem4.fileObj1.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem4.fileObj1.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem4.fileObj1.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem4" filePathKey="fileObj1"
                      senum="2" value="" />

                    <p></p>
                    <label>附件（企业排放总量）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem4.fileObj2.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem4.fileObj2.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem4.fileObj2.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem4" filePathKey="fileObj2"
                      senum="2" value="" />

                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem4.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="5、危险废物管理与处置【企业自评与填报】" name="8">
                    <template #title>
                      <span>5、危险废物管理与处置【企业自评与填报】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem5.remark"></el-input>
                    <p></p>
                    <el-checkbox v-if="!reviewSubmitDatas.reviewItem5.radioSelect3"
                      v-model="reviewSubmitDatas.reviewItem5.radioSelect1">无危险废物处置要求的(5.5分)</el-checkbox>
                    <p></p>
                    <div v-if="!reviewSubmitDatas.reviewItem5.radioSelect1">
                      <div v-if="!reviewSubmitDatas.reviewItem5.radioSelect3">
                        <el-radio style="font-weight: bold" v-model="reviewSubmitDatas.reviewItem5.radioSelect4"
                          label="0">
                          按照《危险废物规范化管理指标体系》（环办〔2011〕48
                          号）开展危险废物规范化管理考核</el-radio>
                        <!-- <p>按照《危险废物规范化管理指标体系》（环办〔2011〕48 号）开展危险废物规范化管理考核</p> -->
                        <br />
                        <el-radio-group :disabled="reviewSubmitDatas.reviewItem5.radioSelect4 == 1
                          " v-model="reviewSubmitDatas.reviewItem5.radioSelect2" class="radioDiv">
                          <div> <el-radio :label="1">完全达标（5.5分）</el-radio></div>
                          <div> <el-radio :label="2">基本达标（3分）</el-radio></div>
                          <div> <el-radio :label="3">不达标（0分）</el-radio></div>
                        </el-radio-group>
                        <p></p>

                        <el-radio style="font-weight: bold" v-model="reviewSubmitDatas.reviewItem5.radioSelect4"
                          label="1">
                          未开展危险废物规范化管理考核的
                        </el-radio>
                        <br />

                        <el-checkbox-group :disabled="reviewSubmitDatas.reviewItem5.radioSelect4 == 0
                          " v-model="reviewSubmitDatas.reviewItem5.selectedOptions
                            ">
                          <!-- <p>未开展危险废物规范化管理考核的</p> -->
                          <el-checkbox label="1">按要求申报登记（1分）</el-checkbox><br />
                          <el-checkbox label="2">按要求规范管理、贮存（2分）</el-checkbox><br />
                          <el-checkbox label="3">按要求转移处置（2.5分）</el-checkbox>
                        </el-checkbox-group>
                      </div>
                      <p></p>
                      <el-checkbox v-model="reviewSubmitDatas.reviewItem5.radioSelect3">
                        非法排放、倾倒、处置危险废物等违法行为，存在任意一种情形的（0分）
                      </el-checkbox>
                    </div>

                    <p></p>
                    <label>附件（情况说明或考核表）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem5.fileObj1.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem5.fileObj1.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem5.fileObj1.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem5" filePathKey="fileObj1"
                      senum="2" value="" />

                    <p></p>
                    <p></p>
                    <label>附件(申报登记): </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem5.fileObj2.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem5.fileObj2.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem5.fileObj2.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem5" filePathKey="fileObj2"
                      senum="2" value="" />

                    <p></p>
                    <p></p>
                    <label>附件(规范管理，贮存): </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem5.fileObj3.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem5.fileObj3.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem5.fileObj3.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem5" filePathKey="fileObj3"
                      senum="2" value="" />

                    <p></p>
                    <p></p>
                    <label>附件(转移处置): </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem5.fileObj4.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem5.fileObj4.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem5.fileObj4.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem5" filePathKey="fileObj4"
                      senum="2" value="" />

                    <p></p>
                    得分值：<span>{{
                      reviewSubmitDatas.reviewItem5.score
                    }}</span>
                    <br />
                  </el-collapse-item>
                  <el-collapse-item title="6、固体废物利用处置【企业自评与填报】" name="9">
                    <template #title>
                      <span>6、固体废物利用处置【企业自评与填报】</span>
                    </template>
                    <span style="padding-right: 6px">企业说明</span>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem6.remark"></el-input>
                    <p></p>
                    <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem6.radioSelect">
                      <div>
                        <el-radio :label="1">固体废物平均利用、处置率≥90%（3分）</el-radio>
                      </div>

                      <div> <el-radio :label="2">80%≤固体废物平均利用、处置率＜90%（2分）</el-radio></div>
                      <div> <el-radio :label="3">60%≤固体废物平均利用、处置率＜80%（1分）</el-radio></div>
                      <div> <el-radio :label="4">固体废物平均利用、处置率＜60%（0分）</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件（台账、合同等）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem6.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem6.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem6.fileObj.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem6" filePathKey="fileObj"
                      senum="2" value="" />
                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem6.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="7、污染治理设施运行【企业自评与填报】" name="10">
                    <template #title>
                      <span>7、污染治理设施运行【企业自评与填报】</span>
                    </template>
                    <span style="padding-right: 6px">企业说明</span>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem7.remark"></el-input>
                    <div v-if="!reviewSubmitDatas.reviewItem7.radioSelect3">
                      <p></p>
                      <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem7.radioSelect1">
                        <div><el-radio :label="1">治污设施正常运转率≥95%（5分）</el-radio></div>
                        <div> <el-radio :label="2">75%≤治污设施正常运转率＜95%（4分）</el-radio></div>
                        <div> <el-radio :label="3">50%≤治污设施正常运转率＜75%（3分）</el-radio></div>
                        <div> <el-radio :label="4">治污设施正常运转率＜50%（1分）</el-radio></div>
                      </el-radio-group>
                      <p></p>
                      <el-checkbox v-model="reviewSubmitDatas.reviewItem7.radioSelect2">
                        排放污染物的浓度与总量稳定达标排放（2分）
                      </el-checkbox>
                    </div>
                    <p></p>
                    <el-checkbox v-model="reviewSubmitDatas.reviewItem7.radioSelect3">
                      存在故意不正常使用治污设施或擅自闲置、拆除治污设施的（0分）
                    </el-checkbox>
                    <p class="fileText"></p>
                    <label>附件1（运行和维护）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem7.fileObj1.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem7.fileObj1.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem7.fileObj1.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem7" filePathKey="fileObj1"
                      senum="2" value="" />
                    <p class="fileText"></p>
                    <label>附件2（浓度和总量）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem7.fileObj2.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem7.fileObj2.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem7.fileObj2.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem7" filePathKey="fileObj2"
                      senum="2" value="" />
                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem7.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="8、排污申报【企业自评与填报】" name="11">
                    <template #title>
                      <span>8、排污申报【企业自评与填报】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem8.remark"></el-input>
                    <p></p>
                    <el-radio-group v-model="reviewSubmitDatas.reviewItem8.radioSelect" class="radioDiv">
                      <div><el-radio :label="1">按规定进行排污申报（2分）</el-radio></div>
                      <div> <el-radio :label="2">未按规定进行排污申报（0分）</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件（申报资料）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem8.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem8.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem8.fileObj.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem8" filePathKey="fileObj"
                      senum="2" value="" />

                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem8.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="9、依法缴纳排污费或环保税【企业自评与填报】" name="12">
                    <template #title>
                      <span>9、依法缴纳排污费或环保税【企业自评与填报】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem9.remark"></el-input>
                    <p></p>
                    <el-radio-group v-model="reviewSubmitDatas.reviewItem9.radioSelect" class="radioDiv">
                      <div> <el-radio :label="1">按规定足额缴纳（2分）</el-radio></div>
                      <div> <el-radio :label="2">未按规定足额缴纳（0分）</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件（环保税资料）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem9.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem9.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem9.fileObj.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem9" filePathKey="fileObj"
                      senum="2" value="" />

                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem9.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="10、排污口规范【企业自评与填报】" name="13">
                    <template #title>
                      <span>10、排污口规范【企业自评与填报】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem10.remark"></el-input>
                    <p></p>
                    <el-radio-group v-model="reviewSubmitDatas.reviewItem10.radioSelect" class="radioDiv">
                      <div> <el-radio :label="1">企业的排污口设置符合规范要求（2分）</el-radio></div>
                      <div> <el-radio :label="2">企业的排污口设置不符合规范要求（0分）</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件（排污口资料）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem10.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem10.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem10.fileObj.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem10" filePathKey="fileObj"
                      senum="2" value="" />

                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem10.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="11、建设项目环评审批及“三同时”制度执行情况【企业自评与填报】" name="14">
                    <template #title>
                      <span>11、建设项目环评审批及“三同时”制度执行情况【企业自评与填报】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem11.remark"></el-input>
                    <p></p>
                    <el-radio-group v-model="reviewSubmitDatas.reviewItem11.radioSelect1" class="radioDiv">
                      <div> <el-radio :label="1">依法按程序取得环境影响评价审批文件（4分）</el-radio></div>
                      <div> <el-radio :label="2">未依法按程序取得环境影响评价审批文件（0分）</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <el-radio-group v-model="reviewSubmitDatas.reviewItem11.radioSelect2" class="radioDiv">
                      <div> <el-radio :label="1">严格执行建设项目环保“三同时”制度（4分）</el-radio></div>
                      <div> <el-radio :label="2">未执行建设项目环保“三同时”制度（0分）</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件（环评全本、批复等）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem11.fileObj1.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem11.fileObj1.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem11.fileObj1.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem11" filePathKey="fileObj1"
                      senum="2" value="" />

                    <br />
                    <p></p>
                    <label>附件（三同时、验收等）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem11.fileObj2.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem11.fileObj2.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem11.fileObj2.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem11" filePathKey="fileObj2"
                      senum="2" value="" />

                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem11.score
                      }}</span>
                    </p>
                  </el-collapse-item>

                  <el-collapse-item title="12、企业环境保护责任制度落实（环保机构、人员、制度等）【企业自评与填报】" name="15">
                    <template #title>
                      <span>12、企业环境保护责任制度落实（环保机构、人员、制度等）【企业自评与填报】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem12.remark"></el-input>
                    <p></p>
                    <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem12.radioSelect">
                      <div> <el-radio :label="1">有专职环保机构和人员（2分）</el-radio></div>
                      <div> <el-radio :label="2">有兼职环保机构和人员（1分）</el-radio></div>
                      <div> <el-radio :label="3">无环保机构和人员（0分）</el-radio></div>
                    </el-radio-group>
                    <p>有满足企业环境管理需要的相应制度（1分/项，最高2分）</p>
                    <el-checkbox-group :max="2" v-model="reviewSubmitDatas.reviewItem12.selectedOptions">
                      <el-checkbox label="1">环保岗位责任制度(1分)</el-checkbox>
                      <br />
                      <el-checkbox label="2">环保设施运行管理制度(1分)</el-checkbox>
                      <br />
                      <el-checkbox label="3">环保信用报告制度(1分)</el-checkbox>
                      <br />
                      <el-checkbox label="4">环保档案管理制度等(1分)</el-checkbox>
                    </el-checkbox-group>

                    <p></p>
                    <label>附件(环保机构和人员): </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem12.fileObj1.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem12.fileObj1.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem12.fileObj1.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem12" filePathKey="fileObj1"
                      senum="2" value="" />
                    <p></p>
                    <label>附件(制度1): </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem12.fileObj2.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem12.fileObj2.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem12.fileObj2.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem12" filePathKey="fileObj2"
                      senum="2" value="" />

                    <p></p>
                    <label>附件(制度2): </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem12.fileObj3.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem12.fileObj3.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem12.fileObj3.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem12" filePathKey="fileObj3"
                      senum="2" value="" />

                    <!-- <p></p>
					  		<label>附件4: </label>
					  		<span style="color: blue; cursor: pointer"
					  			@click="checkFile(reviewSubmitDatas.reviewItem12.fileObj4.filePath)"
					  			v-if="reviewSubmitDatas.reviewItem12.fileObj4.filePath">{{ getFileName(reviewSubmitDatas.reviewItem12.fileObj4.filePath) }}</span>
					  		<input v-else   type="file"
                accept=".pdf,image/*" objName="reviewItem12" filePathKey="fileObj4" senum="2" value="" />
					  		<p></p>
					  		<label>附件5: </label>
					  		<span style="color: blue; cursor: pointer"
					  			@click="checkFile(reviewSubmitDatas.reviewItem12.fileObj5.filePath)"
					  			v-if="reviewSubmitDatas.reviewItem12.fileObj5.filePath">{{ getFileName(reviewSubmitDatas.reviewItem12.fileObj5.filePath) }}</span>
					  		<input v-else   type="file"
                accept=".pdf,image/*" objName="reviewItem12" filePathKey="fileObj5" senum="2" value="" /> -->

                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem12.score
                      }}</span>
                    </p>
                    <p></p>
                  </el-collapse-item>
                  <el-collapse-item title="13、环境风险管理【企业自评与填报】" name="16">
                    <template #title>
                      <span>13、环境风险管理【企业自评与填报】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem13.remark"></el-input>
                    <p></p>
                    <el-checkbox v-model="reviewSubmitDatas.reviewItem13.radioSelect">无环境风险管理要求(3分)
                    </el-checkbox>
                    <p></p>
                    <el-checkbox-group v-if="!reviewSubmitDatas.reviewItem13.radioSelect"
                      v-model="reviewSubmitDatas.reviewItem13.selectedOptions">
                      <el-checkbox label="1">按要求编制应急预案并进行备案(1分)</el-checkbox>
                      <br />
                      <el-checkbox label="2">按要求开展风险隐患排查(1分)</el-checkbox>
                      <br />
                      <el-checkbox label="3">定期组织应急演练(1分)</el-checkbox>
                    </el-checkbox-group>
                    <p></p>
                    <label>附件1（情况说明或预案全本及备案表）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem13.fileObj1.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem13.fileObj1.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem13.fileObj1.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem13" filePathKey="fileObj1"
                      senum="2" value="" />

                    <br />
                    <label>附件2（排查台账）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem13.fileObj2.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem13.fileObj2.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem13.fileObj2.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem13" filePathKey="fileObj2"
                      senum="2" value="" />

                    <br />
                    <label>附件3（方案、照片等）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem13.fileObj3.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem13.fileObj3.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem13.fileObj3.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem13" filePathKey="fileObj3"
                      senum="2" value="" />

                    <br />
                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem13.score
                      }}</span>
                    </p>
                    <p></p>
                  </el-collapse-item>
                  <el-collapse-item title="14、环境统计填报【企业自评与填报】" name="17">
                    <template #title>
                      <span>14、环境统计填报【企业自评与填报】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem14.remark"></el-input>
                    <p></p>
                    <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem14.radioSelect">
                      <div> <el-radio :label="1">按期、如实填报环境统计信息或无环境统计填报要求（2分）</el-radio></div>
                      <div><el-radio :label="2">未按期或不如实填报环境统计信息（0分）</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件（环统）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem14.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem14.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem14.fileObj.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem14" filePathKey="fileObj"
                      senum="2" value="" />

                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem14.score
                      }}</span>
                    </p>
                  </el-collapse-item>

                  <el-collapse-item title="15、环境信息公开【企业自评与填报】" name="18">
                    <template #title>
                      <span>15、环境信息公开【企业自评与填报】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem15.remark"></el-input>
                    <p></p>
                    <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem15.radioSelect">
                      <div><el-radio :label="1">依法公开且公开内容符合规定要求（3分）</el-radio></div>
                      <div> <el-radio :label="2">公开内容不符合规定要求（2分）</el-radio></div>
                      <div> <el-radio :label="3">公开内容弄虚作假、或依法应公开但拒不公开环境信息（0分）</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件（公开）: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem15.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem15.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem15.fileObj.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem15" filePathKey="fileObj"
                      senum="2" value="" />

                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem15.score
                      }}</span>
                    </p>
                  </el-collapse-item>

                  <el-collapse-item title="16、行政处罚【主管部门填报】" name="19">
								<template #title>
									<span>16、行政处罚【主管部门填报】</span>
								</template>
								<span style="padding-right:6px">企业说明</span>
								<el-input style="width:400px" type="textarea" autosize placeholder=""
									v-model="reviewSubmitDatas.reviewItem16.remark"></el-input>

								<p></p>
								<el-input-number :disabled="reviewSubmitDatas.reviewItem16.radioSelect!='0'"
									v-model="reviewSubmitDatas.reviewItem16.counter1" :min="0" label="次" size="mini">
								</el-input-number>
								<span>评价年度内因环境违法行为受到罚款处罚，且单次罚款金额＜10 万（-1/次）</span> <br>
								<el-input-number :disabled="reviewSubmitDatas.reviewItem16.radioSelect!='0'"
									v-model="reviewSubmitDatas.reviewItem16.counter2" :min="0" label="次" size="mini">
								</el-input-number>
								<span>评价年度内因环境违法行为受到行政处罚，且 10 万≤单次罚款金额≤50 万（-2/次）</span> <br>
								<el-input-number :disabled="reviewSubmitDatas.reviewItem16.radioSelect!='0'"
									v-model="reviewSubmitDatas.reviewItem16.counter3" :min="0" label="次" size="mini">
								</el-input-number>
								<span>评价年度内因环境违法行为受到行政处罚，且单次罚款金额＞50 万（-4/次）</span> <br>

								<p></p>
								<el-radio-group v-model="reviewSubmitDatas.reviewItem16.radioSelect">
									<el-radio :label="0">选中以上情形（根据次数扣分）</el-radio><br>

									<el-radio :label="1">评价年度内存在逃避监管等其他严重违法行为受到行政拘留、吊销许可证、责令停产停业等行政处罚的（-8分）</el-radio>
									<br>
									<el-radio :label="2">评价年度内不履行行政处罚决定（-8分）</el-radio><br>
									<el-radio :label="3">评价年度内无因环境违法行为受到行政处罚（8分）</el-radio><br>
								</el-radio-group>
								<p></p>
								<p class="fileText"></p>
								<label>附件: </label>
								<span style="color: blue; cursor: pointer"
									@click="checkFile(reviewSubmitDatas.reviewItem16.fileObj.filePath)"
									v-if="reviewSubmitDatas.reviewItem16.fileObj.filePath">{{getFileName(reviewSubmitDatas.reviewItem16.fileObj.filePath)}}</span>
								<input v-else   type="file"
                accept=".pdf,image/*" objName="reviewItem16" filePathKey="fileObj" senum="2"
									value="" />
								<p>
									得分值：<span>{{ reviewSubmitDatas.reviewItem16.score }}</span>
								</p>
							</el-collapse-item>

							<el-collapse-item title="17、行政命令【主管部门填报】" name="20">
								<template #title>
									<span>17、行政命令【主管部门填报】</span>
								</template>
								<span style="padding-right:6px">企业说明</span>
								<el-input style="width:400px" type="textarea" autosize placeholder="请输入内容"
									v-model="reviewSubmitDatas.reviewItem17.remark"></el-input>
								<p></p>

								<el-input-number :disabled="reviewSubmitDatas.reviewItem17.radioSelect!='0'"
									v-model="reviewSubmitDatas.reviewItem17.counter" :min="0" label="次" size="mini">
								</el-input-number><span>评价年度内因环境违法行为被责令改正，履行相关义务或按期完成整改（-1/次）</span>
								<p></p>
								<el-radio-group v-model="reviewSubmitDatas.reviewItem17.radioSelect">
									<el-radio :label="0">选中以上情形（根据次数扣分）</el-radio><br>
									<el-radio :label="1">评评价年度内因环境违法行为被责令改正，未履行相关义务或未按期完成整改（-5分）</el-radio><br>
									<el-radio :label="2">评价年度内无因环境违法行为受到行政命令（5分）</el-radio><br>

								</el-radio-group>

								<p class="fileText"></p>
								<label>附件: </label>
								<span style="color: blue; cursor: pointer"
									@click="checkFile(reviewSubmitDatas.reviewItem17.fileObj.filePath)"
									v-if="reviewSubmitDatas.reviewItem17.fileObj.filePath">{{getFileName(reviewSubmitDatas.reviewItem17.fileObj.filePath)}}</span>
								<input v-else   type="file"
                accept=".pdf,image/*" objName="reviewItem17" filePathKey="fileObj" senum="2"
									value="" />
								<p>
									得分值：<span>{{ reviewSubmitDatas.reviewItem17.score }}</span>
								</p>
							</el-collapse-item>
							<el-collapse-item title="18、挂牌督办【主管部门填报】" name="21">
								<template #title>
									<span>18、挂牌督办【主管部门填报】</span>
								</template>
								<p>企业说明</p>
								<el-input style="width:400px" type="textarea" autosize placeholder="请输入内容"
									v-model="reviewSubmitDatas.reviewItem18.remark"></el-input>
								<p></p>
								<el-radio-group v-model="reviewSubmitDatas.reviewItem18.radioSelect">
									<el-radio :label="1">评价年度内被市（州）级以上生态生态环境部门挂牌督办（-4分）</el-radio><br>
									<el-radio :label="2">评价年度内无挂牌督办（4分）</el-radio><br>
								</el-radio-group>


								<p></p>
								<label>附件: </label>
								<span style="color: blue; cursor: pointer"
									@click="checkFile(reviewSubmitDatas.reviewItem18.fileObj.filePath)"
									v-if="reviewSubmitDatas.reviewItem18.fileObj.filePath">{{getFileName(reviewSubmitDatas.reviewItem18.fileObj.filePath)}}</span>
								<input v-else   type="file"
                accept=".pdf,image/*" objName="reviewItem18" filePathKey="fileObj" senum="2"
									value="" />



								<p>
									得分值：<span>{{ reviewSubmitDatas.reviewItem18.score }}</span>
								</p>

							</el-collapse-item>

							<el-collapse-item title="19、突发环境事件【主管部门填报】" name="22">
								<template #title>
									<span>19、突发环境事件【主管部门填报】</span>
								</template>
								<p>企业说明</p>
								<el-input style="width:400px" type="textarea" autosize placeholder="请输入内容"
									v-model="reviewSubmitDatas.reviewItem19.remark"></el-input>
								<p>评价年度内取最严重的情形扣一次</p>
								<p></p>
								<el-radio-group v-model="reviewSubmitDatas.reviewItem19.radioSelect">
									<el-radio :label="1">评价年度内发生一般突发环境事件（-4分）</el-radio><br>
									<el-radio :label="2">评价年度内发生较大突发环境事件（-6分）</el-radio><br>
									<el-radio :label="3">评价年度内发生重大突发环境事件（-7分）</el-radio><br>
									<el-radio :label="4">评价年度内发生特大突发环境事件（-8分）</el-radio><br>
									<el-radio :label="5">评价年度内无突发环境事件（8分）</el-radio><br>
								</el-radio-group>


								<p></p>
								<label>附件: </label>
								<span style="color: blue; cursor: pointer"
									@click="checkFile(reviewSubmitDatas.reviewItem19.fileObj.filePath)"
									v-if="reviewSubmitDatas.reviewItem19.fileObj.filePath">{{getFileName(reviewSubmitDatas.reviewItem19.fileObj.filePath)}}</span>
								<input v-else   type="file"
                accept=".pdf,image/*" objName="reviewItem19" filePathKey="fileObj" senum="2"
									value="" />



								<p>
									得分值：<span>{{ reviewSubmitDatas.reviewItem19.score }}</span>
								</p>

							</el-collapse-item>

							<el-collapse-item title="20、信访投诉【主管部门填报】" name="23">
								<template #title>
									<span>20、信访投诉【主管部门填报】</span>
								</template>
								<p>企业说明</p>
								<el-input style="width:400px" type="textarea" autosize placeholder="请输入内容"
									v-model="reviewSubmitDatas.reviewItem20.remark"></el-input>

								<p></p>
								<el-radio-group v-model="reviewSubmitDatas.reviewItem20.radioSelect">
									<el-radio :label="1">评价年度内经查实，确因环境污染造成 1 起群众投诉的（来访投诉、来信投诉、电话投诉 、网络投诉）（-1分）
									</el-radio>
									<br>
									<el-radio :label="2">评价年度内经查实，确因环境污染造成 2 起群众投诉的（来访投诉、来信投诉、电话投诉 、网络投诉）（-3分）
									</el-radio>
									<br>
									<el-radio :label="3">评价年度内经查实，确因环境污染造成 3 起及以上群众投诉的（来访投诉、来信投诉、电话投诉 、网络投诉）（-5分）
									</el-radio>
									<br>
									<el-radio :label="4">评价年度内未受到群众环境信访、投诉或经查实环境信访投诉反映情况不属实的（5分）</el-radio><br>
								</el-radio-group>


								<p></p>
								<label>附件: </label>
								<span style="color: blue; cursor: pointer"
									@click="checkFile(reviewSubmitDatas.reviewItem20.fileObj.filePath)"
									v-if="reviewSubmitDatas.reviewItem20.fileObj.filePath">{{getFileName(reviewSubmitDatas.reviewItem20.fileObj.filePath)}}</span>
								<input v-else   type="file"
                accept=".pdf,image/*" objName="reviewItem20" filePathKey="fileObj" senum="2"
									value="" />



								<p>
									得分值：<span>{{ reviewSubmitDatas.reviewItem20.score }}</span>
								</p>

							</el-collapse-item>

                  <el-collapse-item title="21、清洁生产审核【加分项】" name="24">
                    <template #title>
                      <span>21、清洁生产审核【加分项】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem21.remark"></el-input>

                    <p></p>
                    <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem21.radioSelect">
                      <div><el-radio :label="1">评价年度内未纳入强制性清洁生产审核范围但主动开展清洁生产审核并完成评估验收(2分)</el-radio></div>
                      <div> <el-radio :label="2">评价年度内未纳入强制性清洁生产审核范围且未开展清洁生产审核并完成评估验收(0分)</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem21.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem21.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem21.fileObj.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem21" filePathKey="fileObj"
                      senum="2" value="" />
                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem21.score
                      }}</span>
                    </p>
                  </el-collapse-item>

                  <el-collapse-item title="22、环境管理体系认证【加分项】" name="25">
                    <template #title>
                      <span>22、环境管理体系认证【加分项】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem22.remark"></el-input>

                    <p></p>
                    <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem22.radioSelect">
                      <div> <el-radio :label="1">评价年度内获得 ISO14001 环境管理体系认证并在有效期内(2分)</el-radio></div>
                      <div> <el-radio :label="2">评价年度内未获得 ISO14001 环境管理体系认证(0分)</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem22.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem22.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem22.fileObj.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem22" filePathKey="fileObj"
                      senum="2" value="" />

                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem22.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="23、环境污染责任保险【加分项】" name="26">
                    <template #title>
                      <span>23、环境污染责任保险【加分项】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem23.remark"></el-input>

                    <p></p>
                    <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem23.radioSelect">
                      <div> <el-radio :label="1">评价年度内参保环境污染责任保险(2分)</el-radio></div>
                      <div> <el-radio :label="2">评价年度内未参保环境污染责任保险(0分)</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem23.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem23.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem23.fileObj.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem23" filePathKey="fileObj"
                      senum="2" value="" />
                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem23.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="24、环境责任报告【加分项】" name="27">
                    <template #title>
                      <span>24、环境责任报告【加分项】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem24.remark"></el-input>
                    <p></p>
                    <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem24.radioSelect">
                      <div> <el-radio :label="1">评价年度内主动发布社会环境责任报告(1分)</el-radio></div>
                      <div> <el-radio :label="2">评价年度内未发布社会环境责任报告(0分)</el-radio></div>
                    </el-radio-group>
                    <p></p>
                    <label>附件: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem24.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem24.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem24.fileObj.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem24" filePathKey="fileObj"
                      senum="2" value="" />
                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem24.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                  <el-collapse-item title="25、表彰【加分项】" name="28">
                    <template #title>
                      <span>25、表彰【加分项】</span>
                    </template>
                    <p>企业说明</p>
                    <el-input style="width: 400px" type="textarea" autosize placeholder="请输入内容"
                      v-model="reviewSubmitDatas.reviewItem25.remark"></el-input>
                    <el-checkbox-group v-model="reviewSubmitDatas.reviewItem25.selectedOptions"
                      @change="excludeSwitch('reviewItem25')">
                      <el-checkbox label="1" :disabled="reviewSubmitDatas.reviewItem25.selectedOptions.includes(
                        '0'
                      )
                        ">
                        评价年度内受到生态环境部表彰(2分)</el-checkbox>
                      <br />
                      <el-checkbox label="2" :disabled="reviewSubmitDatas.reviewItem25.selectedOptions.includes(
                        '0'
                      )
                        ">
                        评价年度内受到省生态环境厅表彰(1分)</el-checkbox>
                      <br />
                      <el-checkbox label="0">评价年度内未受到表彰(0分)</el-checkbox>
                    </el-checkbox-group>

                    <label>附件: </label>
                    <span style="color: blue; cursor: pointer" @click="
                      checkFile(
                        reviewSubmitDatas.reviewItem25.fileObj.filePath
                      )
                      " v-if="reviewSubmitDatas.reviewItem25.fileObj.filePath">{{
                        getFileName(
                          reviewSubmitDatas.reviewItem25.fileObj.filePath
                        )
                      }}</span>
                    <input v-else type="file" accept=".pdf,image/*" objName="reviewItem25" filePathKey="fileObj"
                      senum="2" value="" />
                    <p>
                      得分值：<span>{{
                        reviewSubmitDatas.reviewItem25.score
                      }}</span>
                    </p>
                  </el-collapse-item>
                </el-collapse>
              </el-col>
              <el-col :span="13">
                <el-container>
                  <div style="
                      width: 100%;
                      margin-left: 20px;
                      height: 790px;
                      overflow: scroll;
                      overflow-x: hidden;
                    ">
                    <h2>
                      指标审核
                      <!-- <span style="font-size: 16px; color: red"
                    >2020年度信用等级：{{
                      year2020 || "暂无"
                    }}
                    2021年度信用等级：{{ year2021 || "暂无" }}</span
                  > -->
                    </h2>
                    <el-form v-model="form" label-width="140px" label-position="left">
                      <el-popover placement="bottom" trigger="hover" width="400px">
                        <template #reference>
                          <el-button style="margin-right: 16px" type="primary">查看历年等级</el-button>
                        </template>
                        <el-table :data="companyYearHistory">
                          <el-table-column property="name" label="评价项目" />
                          <el-table-column property="code" label="等级" />
                        </el-table>
                      </el-popover>
                      <el-form-item label="评价指标:">
                        <el-select v-model="indexSelect" placeholder="请选择" @change="getAuditItem">
                          <el-option v-for="item in indexSelectList" :key="item.value" :label="item.label"
                            :value="item">
                          </el-option>
                        </el-select>
                        <!-- resultObj -->
                      </el-form-item>
                      <el-form-item label="分数选项:">
                        <el-radio-group v-model="radioSelect">
                          <el-radio label="1">加分</el-radio>
                          <el-radio label="-1">扣分</el-radio>
                          <el-radio label="0">提示</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="指标项:">
                        <el-checkbox-group v-model="checkList">
                          <el-checkbox style="display: block" v-for="item in indexSelectItemList" :key="item.value"
                            :label="item" :value="item">{{ item.label }} （{{ item.score }}分）
                          </el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                      <el-form-item label="【审核/补充】资料:">
                        <el-upload class="upload-demo" action="#" :http-request="handleUpload" :file-list="fileList"
                          ref="my-upload">
                          <el-button size="small" type="primary">点击上传</el-button>
                          <template #tip>
                            <div class="el-upload__tip">
                              只能上传 pdf/jpg/png 文件（可选）
                            </div>
                          </template>
                        </el-upload>
                      </el-form-item>
                      <el-form-item label="【审核/补充】意见:">
                        <textarea autocomplete="off" style="
                            min-height: 40px;
                            height: 50px;
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 370px;
                          " v-model="verifyRemark"></textarea>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="saveVerifyStep">保存【审核/补充】项</el-button>
                        <el-button type="primary" @click="finishVerify">全部完成审核工作并【提交】</el-button>
                        <!-- <el-button type="success" @click='generateReport' icon="el-icon-document">生成信用报告</el-button> -->
                      </el-form-item>
                    </el-form>
                    <el-tabs v-model="tabs" @tab-click="handleClick2">

                      <el-tab-pane v-for="(item, index) in stepList" :key="index" :label="item.step.flowStepname"
                        :name='item.step.flowStepname'>
                        <div>
                          <div>
                            <p>
                              企业自评：{{ reviewDatas.score1 }}
                              {{ reviewDatas.scorelevel1 }}
                            </p>
                            <p>
                              审核分数：{{ item.step.score2 }}
                              {{ item.step.scorelevel2.slice(0, 4) }}
                              {{ levelSort(item.step.score2) }}
                            </p>
                          </div>
                          <el-button type="primary" @click="deleteVerifySteps()" v-if="tabListNum == 0">多选删除
                          </el-button>
                          <!-- <el-button
                            type="primary"
                            style="background-color: #0086b3"
                            @click="exportExcel"
                            >导出
                          </el-button> -->
                          <el-table v-if="tableData2.length" :data="tableData2" stripe
                            @selection-change="handleSelectionChange" class="table_v" height="700" style="width: 100%">
                            <el-table-column type="selection" width="65">
                            </el-table-column>
                            <el-table-column type="index" label="序号">
                            </el-table-column>
                            <el-table-column prop="itemTitle" label="审核指标" sortable width="100" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="auditsItemNames" label="审核项" sortable width="100">
                            </el-table-column>
                            <el-table-column prop="creatorName" label="审核人" sortable width="100" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="score" label="分数" sortable width="80">
                            </el-table-column>
                            <el-table-column label="审核时间" width="100">
                              <template #default="scope">
                                <p>
                                  {{ dateTrimmer(scope.row.createTime) }}
                                </p>
                                <p>{{ timeTrimmer(scope.row.createTime) }}</p>
                              </template>
                            </el-table-column>
                            <el-table-column label="补充资料" sortable width="100">
                              <template #default="scope">
                                <p @click="checkMoreFile(scope.row.fileUrl)" v-if="scope.row.fileUrl"
                                  style="color: #0080ff">
                                  查看资料
                                </p>
                                <p v-else>无补充资料</p>
                              </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="审核意见" sortable width="200">
                            </el-table-column>
                            <el-table-column label="审核状态" v-if="tabListNum == 0">
                              <template #default="scope">
                                <p v-if="scope.row.isFromLast != 1" style="color: red">
                                  当前审核
                                </p>
                                <p v-else style="color: green">过往审核</p>
                              </template>
                            </el-table-column>
                            <el-table-column label="操作" v-if="tabListNum == 0">
                              <template #default="scope">
                                <el-button type="primary" @click="deleteVerifyStep(scope.row)">
                                  删除
                                </el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                      </el-tab-pane>
                      <el-tab-pane name="appealList">
                        <template #label>
                          <span>申诉材料</span>
                        </template>

                        <div>
                          <el-table :data="tableData222" style="width: 100%">


                            <el-table-column prop="appraiseAudsName" sortable label="评价指标" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="appealContent" label="内容" show-overflow-tooltip>
                            </el-table-column>

                            <el-table-column label="附件">
                              <template #default="scope">
                                <a download target='_blank' :href="BASE_URL + scope.row.appealFileUrl">{{
                                  getFileName(scope.row.appealFileUrl)
                                  }}</a>
                              </template>
                            </el-table-column>
                            <el-table-column label="创建时间">
                              <template #default="scope">
                                {{ scope.row.createTime.split("T")[0] }}
                                <br />
                                {{ scope.row.createTime.split("T")[1] }}
                              </template>
                            </el-table-column>
                            <el-table-column label="审核时间">
                              <template #default="scope">
                                <template v-if="scope.row.auditTime">
                                  {{ scope.row.auditTime.split("T")[0] }}
                                  <br />
                                  {{ scope.row.auditTime.split("T")[1] }}
                                </template>

                              </template>
                            </el-table-column>
                            <el-table-column label="操作">
                              <template #default="scope">
                                <template v-if="scope.row.status == 0">
                                  <el-popconfirm title="确定要标为已处理吗？" @confirm="dealAppeal(scope.row.id)">
                                    <template #reference>
                                      <el-button size="small" type="success"
                                        style="margin-bottom: 2px; margin-right: 2px">标为已处理</el-button>
                                    </template>
                                  </el-popconfirm>
                                </template>
                              </template>
                            </el-table-column>
                          </el-table>
                          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="pageInfo.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                            :page-size="10" layout="total, sizes, prev, pager, next, jumper"
                            :total="pageInfo.totalRowCount" v-if="tableData222.length">
                          </el-pagination>
                        </div>
                      </el-tab-pane>
                      <!-- <el-tab-pane label="信用报告" name="second">
										<el-button type="primary" @click='reportVisible = true'>上传报告</el-button>
										<el-divider></el-divider>
										<el-form :model="form4" label-width="124px" :label-position="labelPosition2">
											<el-form-item label="报告编号">
												<div v-if="reportDatas">{{reportDatas.Code}}</div>
												<div v-else>暂无报告</div>
											</el-form-item>
											<el-form-item label="报告文件">
												<el-link v-if="reportDatas" @click="checkReportFile(reportDatas.FileUrl)">查看报告</el-link>
												<el-link v-else>无文件</el-link>
											</el-form-item>
											<el-form-item label="报告创建时间">
												<div v-if="reportDatas">{{ dateTrimmer(reportDatas.CreateTime) }}
													{{timeTrimmer(reportDatas.CreateTime)}}
												</div>
												<div v-else>无文件</div>
											</el-form-item>
										</el-form>
									</el-tab-pane> -->
                    </el-tabs>
                  </div>

                  <!-- <el-dialog title="上传报告" :visible.sync="reportVisible" width="40%">
					  		<el-form :model="form3" label-width="124px" size='mini' :label-position="labelPosition">
					  
					  			<el-upload class="upload-demo" action="" :http-request="handleUploadReport">
					  				<el-button size="small" type="primary">点击上传</el-button>
					  				<template #tip>
					  					<div class="el-upload__tip">只能上传 pdf/jpg/png 文件</div>
					  				</template>
					  			</el-upload>
					  
					  		</el-form>
					  		<el-button style="primary" @click='uploadReport'>确定</el-button>
					  	</el-dialog> -->
                </el-container>
              </el-col>
            </el-row>
          </el-tab-pane>

          <!-- <el-tab-pane label="主管部门审核" name="second">
            <el-collapse>
              <el-collapse-item title="16、行政处罚【主管部门填报】" name="19">
                <template #title>
                  <span style="color: #1d8c3a; font-weight: bold">16、行政处罚【主管部门填报】</span>
                </template>
                <span style="padding-right: 6px">企业说明</span>
                <el-input style="width: 600px" type="textarea" autosize placeholder=""
                  v-model="reviewSubmitDatas.reviewItem16.remark"></el-input>
                <br />
                <el-image style="
                    height: 150px;
                    width: 267px;
                    float: right;
                    margin: 20px 80px 20px 0px;
                  " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_16.jpg')
                    " :preview-src-list="[
                    require('../../assets/images/guizhouReviewHints/guizhouHints_16.jpg'),
                  ]">
                </el-image>

                <p></p>
                <el-input-number :disabled="reviewSubmitDatas.reviewItem16.radioSelect != '0'"
                  v-model="reviewSubmitDatas.reviewItem16.counter1" :min="0" label="次" size="mini">
                </el-input-number>
                <span>评价年度内因环境违法行为受到罚款处罚，且单次罚款金额＜10
                  万（-1/次）</span>
                <br />
                <el-input-number :disabled="reviewSubmitDatas.reviewItem16.radioSelect != '0'"
                  v-model="reviewSubmitDatas.reviewItem16.counter2" :min="0" label="次" size="mini">
                </el-input-number>
                <span>评价年度内因环境违法行为受到行政处罚，且 10
                  万≤单次罚款金额≤50 万（-2/次）</span>
                <br />
                <el-input-number :disabled="reviewSubmitDatas.reviewItem16.radioSelect != '0'"
                  v-model="reviewSubmitDatas.reviewItem16.counter3" :min="0" label="次" size="mini">
                </el-input-number>
                <span>评价年度内因环境违法行为受到行政处罚，且单次罚款金额＞50
                  万（-4/次）</span>
                <br />

                <p></p>

                <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem16.radioSelect">
                  <div> <el-radio :label="0">选中以上情形（根据次数扣分）</el-radio>
                  </div>
                  <div><el-radio :label="1">评价年度内存在逃避监管等其他严重违法行为受到行政拘留、吊销许可证、责令停产停业等行政处罚的（-8分）</el-radio></div>
                  <div> <el-radio :label="2">评价年度内不履行行政处罚决定（-8分）</el-radio></div>
                  <div> <el-radio :label="3">评价年度内无因环境违法行为受到行政处罚（0分）</el-radio></div>
                </el-radio-group>
                <p></p>
                <p class="fileText"></p>
                <label>附件: </label>
                <span style="color: blue; cursor: pointer" @click="
                  checkFile(reviewSubmitDatas.reviewItem16.fileObj.filePath)
                  " v-if="reviewSubmitDatas.reviewItem16.fileObj.filePath">{{
                    getFileName(reviewSubmitDatas.reviewItem16.fileObj.filePath)
                  }}</span>
                <input v-else type="file" accept=".pdf,image/*" objName="reviewItem16" filePathKey="fileObj" senum="2"
                  value="" @change="handleUploadCheck" />
                <button v-if="reviewSubmitDatas.reviewItem16.fileObj.filePath"
                  @click="reviewSubmitDatas.reviewItem16.fileObj.filePath = ''">
                  重新上传
                </button>

                <p></p>
                <div class="button-container">
                  <p>
                    得分值：<span>{{
                      reviewSubmitDatas.reviewItem16.score
                    }}</span>
                  </p>
                  <el-button type='primary' @click="
                    saveData({ path: 'Div16Save', itemPath: 'reviewItem16' })
                    ">保存</el-button>
                </div>
              </el-collapse-item>

              <el-collapse-item title="17、行政命令【主管部门填报】" name="20">
                <template #title>
                  <span style="color: #1d8c3a; font-weight: bold">17、行政命令【主管部门填报】</span>
                </template>
                <span style="padding-right: 6px">企业说明</span>
                <el-input style="width: 600px" type="textarea" autosize placeholder="请输入内容"
                  v-model="reviewSubmitDatas.reviewItem17.remark"></el-input>
                <br />
                <el-image style="
                    height: 150px;
                    width: 267px;
                    float: right;
                    margin: 20px 80px 20px 0px;
                  " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_17.jpg')
                    " :preview-src-list="[
                    require('../../assets/images/guizhouReviewHints/guizhouHints_17.jpg'),
                  ]">
                </el-image>
                <p></p>

                <el-input-number :disabled="reviewSubmitDatas.reviewItem17.radioSelect != '0'"
                  v-model="reviewSubmitDatas.reviewItem17.counter" :min="0" label="次" size="mini">
                </el-input-number><span>评价年度内因环境违法行为被责令改正，履行相关义务或按期完成整改（-1/次）</span>
                <p></p>
                <div style="width: 660px">
                  <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem17.radioSelect">
                    <div> <el-radio :label="0">选中以上情形（根据次数扣分）</el-radio></div>
                    <div><el-radio :label="1">评评价年度内因环境违法行为被责令改正，未履行相关义务或未按期完成整改（-5分）</el-radio></div>
                    <div> <el-radio :label="2">评价年度内无因环境违法行为受到行政命令（0分）</el-radio></div>
                  </el-radio-group>
                </div>

                <p class="fileText"></p>
                <label>附件: </label>
                <span style="color: blue; cursor: pointer" @click="
                  checkFile(reviewSubmitDatas.reviewItem17.fileObj.filePath)
                  " v-if="reviewSubmitDatas.reviewItem17.fileObj.filePath">{{
                    getFileName(reviewSubmitDatas.reviewItem17.fileObj.filePath)
                  }}</span>
                <input v-else type="file" accept=".pdf,image/*" objName="reviewItem17" filePathKey="fileObj" senum="2"
                  value="" @change="handleUploadCheck" />
                <button v-if="reviewSubmitDatas.reviewItem17.fileObj.filePath"
                  @click="reviewSubmitDatas.reviewItem17.fileObj.filePath = ''">
                  重新上传
                </button>

                <p></p>
                <div class="button-container">
                  <p>
                    得分值：<span>{{
                      reviewSubmitDatas.reviewItem17.score
                    }}</span>
                  </p>
                  <el-button type='primary' @click="
                    saveData({ path: 'Div17Save', itemPath: 'reviewItem17' })
                    ">保存</el-button>
                </div>
              </el-collapse-item>
              <el-collapse-item title="18、挂牌督办【主管部门填报】" name="21">
                <template #title>
                  <span style="color: #1d8c3a; font-weight: bold">18、挂牌督办【主管部门填报】</span>
                </template>
                <span style="padding-right: 6px">企业说明</span>
                <el-input style="width: 600px" type="textarea" autosize placeholder="请输入内容"
                  v-model="reviewSubmitDatas.reviewItem18.remark"></el-input>
                <br />
                <el-image style="
                    height: 150px;
                    width: 267px;
                    float: right;
                    margin: 20px 80px 20px 0px;
                  " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_18.jpg')
                    " :preview-src-list="[
                    require('../../assets/images/guizhouReviewHints/guizhouHints_18.jpg'),
                  ]">
                </el-image>
                <p></p>
                <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem18.radioSelect">
                  <div> <el-radio :label="1">评价年度内被市（州）级以上生态环境部门挂牌督办（-4分）</el-radio></div>
                  <div> <el-radio :label="2">评价年度内无挂牌督办（0分）</el-radio></div>
                </el-radio-group>

                <p class="fileText"></p>
                <label>附件: </label>
                <span style="color: blue; cursor: pointer" @click="
                  checkFile(reviewSubmitDatas.reviewItem18.fileObj.filePath)
                  " v-if="reviewSubmitDatas.reviewItem18.fileObj.filePath">{{
                    getFileName(reviewSubmitDatas.reviewItem18.fileObj.filePath)
                  }}</span>
                <input v-else type="file" accept=".pdf,image/*" objName="reviewItem18" filePathKey="fileObj" senum="2"
                  value="" @change="handleUploadCheck" />
                <button v-if="reviewSubmitDatas.reviewItem18.fileObj.filePath"
                  @click="reviewSubmitDatas.reviewItem18.fileObj.filePath = ''">
                  重新上传
                </button>

                <p></p>
                <div class="button-container">
                  <p>
                    得分值：<span>{{
                      reviewSubmitDatas.reviewItem18.score
                    }}</span>
                  </p>
                  <el-button type='primary' @click="
                    saveData({ path: 'Div18Save', itemPath: 'reviewItem18' })
                    ">保存</el-button>
                </div>
              </el-collapse-item>

              <el-collapse-item title="19、突发环境事件【主管部门填报】" name="22">
                <template #title>
                  <span style="color: #1d8c3a; font-weight: bold">19、突发环境事件【主管部门填报】</span>
                </template>
                <span style="padding-right: 6px">企业说明</span>
                <el-input style="width: 600px" type="textarea" autosize placeholder="请输入内容"
                  v-model="reviewSubmitDatas.reviewItem19.remark"></el-input>
                <br />
                <el-image style="
                    height: 150px;
                    width: 267px;
                    float: right;
                    margin: 20px 80px 20px 0px;
                  " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_19.jpg')
                    " :preview-src-list="[
                    require('../../assets/images/guizhouReviewHints/guizhouHints_19.jpg'),
                  ]">
                </el-image>
                <p>评价年度内取最严重的情形扣一次</p>
                <p></p>
                <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem19.radioSelect">
                  <div> <el-radio :label="1">评价年度内发生一般突发环境事件（-4分）</el-radio></div>
                  <div> <el-radio :label="2">评价年度内发生较大突发环境事件（-6分）</el-radio></div>
                  <div> <el-radio :label="3">评价年度内发生重大突发环境事件（-7分）</el-radio></div>
                  <div> <el-radio :label="4">评价年度内发生特大突发环境事件（-8分）</el-radio></div>
                  <div> <el-radio :label="5">评价年度内无突发环境事件（0分）</el-radio></div>
                </el-radio-group>
                <p class="fileText"></p>
                <label>附件: </label>
                <span style="color: blue; cursor: pointer" @click="
                  checkFile(reviewSubmitDatas.reviewItem19.fileObj.filePath)
                  " v-if="reviewSubmitDatas.reviewItem19.fileObj.filePath">{{
                    getFileName(reviewSubmitDatas.reviewItem19.fileObj.filePath)
                  }}</span>
                <input v-else type="file" accept=".pdf,image/*" objName="reviewItem19" filePathKey="fileObj" senum="2"
                  value="" @change="handleUploadCheck" />
                <button v-if="reviewSubmitDatas.reviewItem19.fileObj.filePath"
                  @click="reviewSubmitDatas.reviewItem19.fileObj.filePath = ''">
                  重新上传
                </button>
                <p></p>
                <div class="button-container">
                  <p>
                    得分值：<span>{{
                      reviewSubmitDatas.reviewItem19.score
                    }}</span>
                  </p>
                  <el-button type='primary' @click="
                    saveData({ path: 'Div19Save', itemPath: 'reviewItem19' })
                    ">保存</el-button>
                </div>
              </el-collapse-item>

              <el-collapse-item title="20、信访投诉【主管部门填报】" name="23">
                <template #title>
                  <span style="color: #1d8c3a; font-weight: bold">20、信访投诉【主管部门填报】</span>
                </template>
                <span style="padding-right: 6px">企业说明</span>
                <el-input style="width: 600px" type="textarea" autosize placeholder="请输入内容"
                  v-model="reviewSubmitDatas.reviewItem20.remark"></el-input>
                <br />
                <el-image style="
                    height: 150px;
                    width: 267px;
                    float: right;
                    margin: 20px 80px 20px 0px;
                  " :src="require('../../assets/images/guizhouReviewHints/guizhouHints_20.jpg')
                    " :preview-src-list="[
                    require('../../assets/images/guizhouReviewHints/guizhouHints_20.jpg'),
                  ]">
                </el-image>
                <p></p>
                <div style="width: 780px">
                  <el-radio-group class="radioDiv" v-model="reviewSubmitDatas.reviewItem20.radioSelect">
                    <div> <el-radio :label="1">评价年度内经查实，确因环境污染造成 1
                        起群众投诉的（来访投诉、来信投诉、电话投诉
                        、网络投诉）（-1分）</el-radio></div>
                    <div> <el-radio :label="2">评价年度内经查实，确因环境污染造成 2
                        起群众投诉的（来访投诉、来信投诉、电话投诉
                        、网络投诉）（-3分）</el-radio></div>
                    <div> <el-radio :label="3">评价年度内经查实，确因环境污染造成 3
                        起及以上群众投诉的（来访投诉、来信投诉、电话投诉
                        、网络投诉）（-5分）</el-radio></div>
                    <div> <el-radio :label="4">评价年度内未受到群众环境信访、投诉或经查实环境信访投诉反映情况不属实的（0分）</el-radio></div>
                  </el-radio-group>
                </div>
                <p class="fileText"></p>
                <label>附件: </label>
                <span style="color: blue; cursor: pointer" @click="
                  checkFile(reviewSubmitDatas.reviewItem20.fileObj.filePath)
                  " v-if="reviewSubmitDatas.reviewItem20.fileObj.filePath">{{
                    getFileName(reviewSubmitDatas.reviewItem20.fileObj.filePath)
                  }}</span>
                <input v-else type="file" accept=".pdf,image/*" objName="reviewItem20" filePathKey="fileObj" senum="2"
                  value="" @change="handleUploadCheck" />
                <button v-if="reviewSubmitDatas.reviewItem20.fileObj.filePath"
                  @click="reviewSubmitDatas.reviewItem20.fileObj.filePath = ''">
                  重新上传
                </button>
                <p></p>
                <div class="button-container">
                  <p>
                    得分值：<span>{{
                      reviewSubmitDatas.reviewItem20.score
                    }}</span>
                  </p>
                  <el-button type='primary' @click="
                    saveData({ path: 'Div20Save', itemPath: 'reviewItem20' })
                    ">保存</el-button>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-tab-pane> -->
          <el-tab-pane label="企业信息" name="third">
            <el-descriptions class="margin-top" :column="2" border>
              <el-descriptions-item label="单位名称" :span="2">
                {{ this.companyDatas.name }}
              </el-descriptions-item>
              <el-descriptions-item label="曾用名">
                {{ this.companyDatas.lastName }}
              </el-descriptions-item>
              <el-descriptions-item label="统一社会信用代码">
                {{ this.companyDatas.orgCode }}
              </el-descriptions-item>
              <el-descriptions-item label="行政区域">
                {{ this.companyDatas.regionName }}
              </el-descriptions-item>
              <el-descriptions-item label="单位地址">
                {{ this.companyDatas.address }}
              </el-descriptions-item>
              <el-descriptions-item label="生产经营">
                {{ this.companyDatas.sCjy }}
              </el-descriptions-item>
              <el-descriptions-item label="企业官网">
                {{ this.companyDatas.qYGW }}
              </el-descriptions-item>
              <el-descriptions-item label="地图（经度）">
                {{ this.companyDatas.orgCode }}
              </el-descriptions-item>
              <el-descriptions-item label="地图（纬度）">
                {{ this.companyDatas.orgCode }}
              </el-descriptions-item>
              <el-descriptions-item label="法人代表">
                {{ this.companyDatas.faRen }}
              </el-descriptions-item>
              <el-descriptions-item label="手机号码">
                {{ this.companyDatas.telephone }}
              </el-descriptions-item>
              <el-descriptions-item label="环保专员">
                {{ this.companyDatas.hBFZR }}
              </el-descriptions-item>
              <el-descriptions-item label="手机号码">
                {{ this.companyDatas.tel }}
              </el-descriptions-item>
              <el-descriptions-item label="联系QQ号">
                {{ this.companyDatas.qQ }}
              </el-descriptions-item>
              <el-descriptions-item label="电子邮箱">
                {{ this.companyDatas.email }}
              </el-descriptions-item>
              <el-descriptions-item label="座机电话">
                {{ this.companyDatas.iSO }}
              </el-descriptions-item>
              <el-descriptions-item label="信用管家">
                {{ this.companyDatas.yJTX }}
              </el-descriptions-item>
              <el-descriptions-item label="地区代码">
                {{ this.companyDatas.areaCode }}
              </el-descriptions-item>
              <el-descriptions-item label="生产规模">
                {{ this.companyDatas.sCGM }}
              </el-descriptions-item>
              <el-descriptions-item label="注册类型">
                {{ this.companyDatas.registType }}
              </el-descriptions-item>
              <el-descriptions-item label="占地面积">
                {{ this.companyDatas.areaAcreage }}
              </el-descriptions-item>
              <el-descriptions-item label="隶属关系">
                {{ this.companyDatas.lSGX }}
              </el-descriptions-item>
              <el-descriptions-item label="信用代码">
                {{ this.companyDatas.xYDM }}
              </el-descriptions-item>
              <el-descriptions-item label="所属行业">
                {{ this.companyDatas.sSHY }}
              </el-descriptions-item>
              <el-descriptions-item label="管控类型">
                {{ this.companyDatas.gKLX }}
              </el-descriptions-item>
              <el-descriptions-item label="投产日期">
                {{ this.companyDatas.workDate }}
              </el-descriptions-item>
              <el-descriptions-item label="年正常生产天数">
                {{ this.companyDatas.workDay }}
              </el-descriptions-item>
              <el-descriptions-item label="单位简介">
                {{ this.companyDatas.qYSM }}
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../http/apis";
// import FileSaver from 'file-saver';
// import XLSX from 'xlsx';
import CONSTS from "../../store/consts";
import { createNamespacedHelpers } from "vuex";
const { mapState: userState, mapMutations: userMutations } =
  createNamespacedHelpers("user");
export default {
  data() {
    return {
      //申诉
      loading: false,
      dialogVisible: false,
      fileName: "",
      value: "",
      uCompanyId: "",
      isFlag: true,
      tableTotal: 0,
      pageInfo: {},
      fileList: [],
      params: {
        headId: 0,
        regionId: 0,
        startIndex: 0,
        page: 1,
        rows: 99,
        order: "desc",
        sort: "createTime",
        value: "",
      },
      form: {
        Remark: "贵州审核申诉",
        UnitId: 0,
        text: "",
        AudsId: 0,
        name: "",
        id: 0,
        myFile: null,
      },
      options: [],
      tableData222: [],
      formData: null,
      BASE_URL: "",
      disabled: false,
      typeVri: "",
      //
      contShow: false,
      aside_width: "80%",
      activeName11: "first",
      tableData: "",
      form3: {},
      form4: {},
      stepList: [],
      reportVisible: false,
      tableData2: "",
      activeIndex: "1",
      activeIndex2: "1",
      radioSelect: "",
      radioSelect2: "",
      indexSelect: "",
      indexSelectList: [],
      indexSelectItemList: [],
      activeName: "",
      unitAppraiseComStepId: "",
      reviewProjectID: "",
      form: {},
      form2: {},
      checkList: [],
      VerifyStep: "",
      verifyRemark: "",
      uappcomid: "",
      uappcomappid: "",
      VerifyStepList: [],
      dialogVisible: false,
      labelPosition: "right",
      labelPosition2: "left",
      reviewDatas: {},
      href11: "",
      dape: [
        {
          file: "",
        },
      ],
      fileUrl: "",
      reportFileUrl: "",
      multipleSelection: [],
      companyDatas: {},
      reportDatas: {},
      companyYearHistory: [],
      tabs: null,

      tabListNum: 0,
      companyRequest: {},
      optionsDatas: {
        companyStatusOptions: [
          {
            value: "1",
            label: "正常生产",
          },
          {
            value: "2",
            label: "连续半年以上停产",
          },
          {
            value: "3",
            label: "连续半年以上未投产",
          },
          {
            value: "4",
            label: "搬迁",
          },
          {
            value: "5",
            label: "关闭",
          },
          {
            value: "6",
            label: "一票否决",
          },
          {
            value: "7",
            label: "异常企业",
          },
        ],
        onePollOutOptions: [
          {
            value: 1,
            label: "(一) 因环境违法相关责任人被追究刑事责任的",
          },
          {
            value: 2,
            label:
              "(二) 私设暗管或者利用渗井、渗坑、裂隙、溶洞等违法排放、倾倒、处置水污染物，或者通过私设旁路违法排放大气污染物的",
          },
          {
            value: 3,
            label: "(三) 发生较大以上突发环境事件、环境保护群体性事件的",
          },
          {
            value: 4,
            label:
              "(四) 环评、监测、机动车环保检验等服务机构在环境影响评价、社会检测、机动车环保检验工作中弄虚作假，篡改伪造监测数据，帮助业主单位骗取环评审批文件的",
          },
          {
            value: 5,
            label: "(五) 其他造成生态环境严重损害或者造成严重恶劣社会影响的",
          },
        ],
      },
      reviewSubmitDatas: {
        promiseLetter: "",
        basicInfo: {
          remark: "",
          huanPingWenJianList: [
            {
              fileName: "",
              filePath: "",
            },
          ],
          piFuWenJianList: [
            {
              fileName: "",
              filePath: "",
            },
          ],
          yanShouWenJianList: [
            {
              fileName: "",
              filePath: "",
            },
          ],

          tongShiYanShou: {
            fileName: "",
            filePath: "",
          },
          paiWuXuKe: {
            fileName: "",
            filePath: "",
          },
          fengXianPingGu: {
            fileName: "",
            filePath: "",
          },
          yingJiYuAn: {
            fileName: "",
            filePath: "",
          },
        },
        danWeiZhengMing: {
          remark: "",
          xinYongDaiMa: "",
          yinYeZhiZhao: {
            fileName: "",
            filePath: "",
          },
          companyStatus: 1,
        },
        danWeiZhuangTai: {
          year: "",
          companyStatus: "正常生产",
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        yiPiaoFouJue: {
          isNotOnePollOut: false,
          onePollOutList: [],
          score: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem1: {
          remark: "",
          radioSelect1: false,
          radioSelect2: 0,
          selectedOptions: [],
          score: 0,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
          fileObj3: {
            fileName: "",
            filePath: "",
          },
          fileObj4: {
            fileName: "",
            filePath: "",
          },
          fileObj5: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem2: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem3: {
          remark: "",
          score: 0,
          radioSelect1: false,
          radioSelect2: 0,
          radioSelect3: 0,
          selectedOptions: [],
          disableSwitch: false,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
          fileObj3: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem4: {
          remark: "",
          score: 0,
          selectedOptions: [],
          radioSelect1: false,
          radioSelect2: 0,
          radioSelect3: 0,
          disableSwitch: false,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem5: {
          remark: "",
          score: 0,
          radioSelect1: false,
          radioSelect2: 0,
          radioSelect4: 0,
          radioSelect4: 1,
          selectedOptions: [],
          radioSelect3: false,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
          fileObj3: {
            fileName: "",
            filePath: "",
          },
          fileObj4: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem6: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem7: {
          remark: "",
          score: 0,
          radioSelect1: 0,
          radioSelect2: false,
          radioSelect3: false,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem8: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem9: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem10: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem11: {
          remark: "",
          score: 0,
          radioSelect1: 0,
          radioSelect2: 0,
          fileObj1: {
            fileName: "",
            filePath: "",
          },

          fileObj2: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem12: {
          remark: "",
          score: 0,
          radioSelect: 0,
          selectedOptions: [],
          casesNum: 0,
          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
          fileObj3: {
            fileName: "",
            filePath: "",
          },
          fileObj4: {
            fileName: "",
            filePath: "",
          },
          fileObj5: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem13: {
          remark: "",
          score: 0,
          radioSelect: 0,
          selectedOptions: [],

          fileObj1: {
            fileName: "",
            filePath: "",
          },
          fileObj2: {
            fileName: "",
            filePath: "",
          },
          fileObj3: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem14: {
          remark: "",
          score: 0,
          radioSelect: "",
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem15: {
          remark: "",
          score: 0,
          radioSelect: "",
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem16: {
          remark: "",
          counter1: 0,
          counter2: 0,
          counter3: 0,
          radioSelect: 0,
          score: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem17: {
          remark: "",
          score: 0,
          radioSelect: 0,
          counter: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem18: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem19: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem20: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem21: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem22: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem23: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem24: {
          remark: "",
          score: 0,
          radioSelect: 0,
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem25: {
          remark: "",
          score: 0,
          selectedOptions: [],
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem26: {
          remark: "",
          score: 0,
          radioSelect: "",
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
        reviewItem27: {
          remark: "",
          score: 0,
          radioSelect: "",
          fileObj: {
            fileName: "",
            filePath: "",
          },
        },
      },

      year2020: "",
      year2021: "",
    };
  },

  mounted() {
    // this.getStepItemsDatas();
    this.uCompanyId = this.$route.query.unitAID;
    this.getReviewInfo();
    this.getGZReviewAuditList();
    this.getVerifyList();

    this.BASE_URL = CONSTS.BASE_URL.slice(0, -1);
    this.form.unitId = Number(this.$route.query.unitAID);
    this.params.headId = Number(this.$route.query.unitAID);

    this.typeVri = Number(this.$route.query.type);

    this.handleQuery();
  },

  methods: {
    checkFile(filePath) {
      this.BASE_URL = CONSTS.BASE_URL.slice(0, -1);

      window.open(this.BASE_URL + filePath);
    },
    checkMoreFile(filePath) {
      window.open(this.BASE_URL + filePath);
    },
    checkReportFile(filePath) {
      window.open("http://221.10.90.140:8082" + filePath);
    },
    getFileName(val) {
      if (val != null) {
        if (val || val != "") {
          const fileUrl = val.split("/");
          const fileName = fileUrl.pop();
          return fileName;
        } else {
          const str = "无";
          return str;
        }
      }
    },
    getNowYear() {
      let dateObj = new Date();
      const ye = dateObj.getFullYear() - 1;
      this.reviewSubmitDatas.danWeiZhuangTai.year = ye;
    },
    async getReviewInfo() {
      // this.uCompanyId = sessionStorage.getItem('AA')
      // console.info("got company ID", this.uCompanyId);
      const res = await api.reviewTaskApi.getReviewModelByID(this.uCompanyId);

      this.companyDatas = res.data.resultObj.company;
      // console.log(this.companyDatas)
      this.companyRequest = res.data.resultObj.request;
      this.reviewProjectID = res.data.resultObj.request.id;
      this.companyYearHistory = res.data.resultObj.yearHistory
      this.reviewDatas = res.data.resultObj.appcom;
      // this.year2020 = res.data.resultObj.year2020
      // this.year2021 = res.data.resultObj.year2021
      // console.log(this.reviewDatas)
      // console.info("got review project ID", this.reviewProjectID);
      this.getBackUp();
      // this.checkReport();
    },
    checkOrgCode() {
      const orgCode = this.reviewSubmitDatas.danWeiZhengMing.xinYongDaiMa;
      window.open(
        "https://www.creditchina.gov.cn/xinyongfuwu/tongyishehuixinyongdaimachaxunzhuanlan/shehuixinyongdaimachaxun/index.html?index=1&keyword=" +
        orgCode,
        "_blank"
      );
    },
    async getBackUp() {
      const { data } = await api.reviewTaskApi.getReviewModelByID(
        this.uCompanyId
      );
      console.info("ttttt", data);
      if (data.isSuccessful) {
        const t = data.resultObj.request;

        let b = this.reviewSubmitDatas;
        // console.info(t);
        b.danWeiZhengMing.remark = t.divv1t2;
        b.danWeiZhengMing.xinYongDaiMa = t.divv1t1;
        b.danWeiZhengMing.companyStatus = t.companyStatus || 1;
        b.danWeiZhengMing.yinYeZhiZhao.filePath = t.divv1F1;
        b.promiseLetter = t.cndivF1;
        b.reviewItem1.fileObj1.filePath = t.div1F1;
        b.reviewItem1.fileObj2.filePath = t.div1F2;
        b.reviewItem1.fileObj3.filePath = t.div1F3;
        b.reviewItem1.fileObj4.filePath = t.div1F4;
        b.reviewItem1.fileObj5.filePath = t.div1F5;
        if (t.div1r1 == 0) {
          b.reviewItem1.radioSelect1 = false;
        } else {
          b.reviewItem1.radioSelect1 = true;
        }
        b.reviewItem1.selectedOptions = this.deToxicateArr(t.div1r2);
        b.reviewItem1.radioSelect2 = parseInt(t.div1r3);
        b.reviewItem1.remark = t.div1t1;

        b.reviewItem2.fileObj.filePath = t.div2F1;
        b.reviewItem2.radioSelect = parseInt(t.div2r1);
        b.reviewItem2.remark = t.div2t1;

        b.reviewItem3.fileObj1.filePath = t.div3F1;
        b.reviewItem3.fileObj2.filePath = t.div3F2;
        b.reviewItem3.fileObj3.filePath = t.div3F3;
        b.reviewItem3.radioSelect1 = this.radioNumToBoo(t.div3r1);
        b.reviewItem3.radioSelect2 = parseInt(t.div3r2);
        b.reviewItem3.radioSelect3 = parseInt(t.div3r3);
        b.reviewItem3.remark = t.div3t1;

        b.reviewItem4.fileObj1.filePath = t.div4F1;
        b.reviewItem4.fileObj2.filePath = t.div4F2;
        b.reviewItem4.radioSelect1 = this.radioNumToBoo(t.div4r1);
        b.reviewItem4.radioSelect2 = parseInt(t.div4r2);
        b.reviewItem4.radioSelect3 = parseInt(t.div4r3);
        b.reviewItem4.remark = t.div4t1;

        b.reviewItem5.fileObj1.filePath = t.div5F1;
        b.reviewItem5.fileObj2.filePath = t.div5F2;
        b.reviewItem5.fileObj3.filePath = t.div5F3;
        b.reviewItem5.fileObj4.filePath = t.div5F4;
        b.reviewItem5.radioSelect1 = this.radioNumToBoo(t.div5r1);
        b.reviewItem5.radioSelect2 = parseInt(t.div5r2);

        //先注释掉，div5r1默认返回会冲突
        if (t.div5r1 == 1) {
          b.reviewItem5.radioSelect3 = false;
        }
        if (t.div5r4 == 1) {
          b.reviewItem5.radioSelect1 = false;
        }

        b.reviewItem5.selectedOptions = this.deToxicateArr(t.div5r3);
        if (t.div5r5) {
          b.reviewItem5.radioselect4 = parseInt(t.div5r5);
        }
        b.reviewItem5.remark = t.div5t1;

        b.reviewItem6.fileObj.filePath = t.div6F1;
        b.reviewItem6.radioSelect = parseInt(t.div6r1);
        b.reviewItem6.remark = t.div6t1;

        b.reviewItem7.fileObj1.filePath = t.div7F1;
        b.reviewItem7.fileObj2.filePath = t.div7F2;
        b.reviewItem7.radioSelect1 = parseInt(t.div7r1);
        b.reviewItem7.radioSelect2 = this.radioNumToBoo(t.div7r2);
        b.reviewItem7.radioSelect3 = this.radioNumToBoo(t.div7r3);
        b.reviewItem7.remark = t.div7t1;

        b.reviewItem8.fileObj.filePath = t.div8F1;
        b.reviewItem8.radioSelect = parseInt(t.div8r1);
        b.reviewItem8.remark = t.div8t1;

        b.reviewItem9.fileObj.filePath = t.div9F1;
        b.reviewItem9.radioSelect = parseInt(t.div9r1);
        b.reviewItem9.remark = t.div9t1;

        b.reviewItem10.fileObj.filePath = t.div10F1;
        b.reviewItem10.radioSelect = parseInt(t.div10r1);
        b.reviewItem10.remark = t.div10t1;

        b.reviewItem11.radioSelect1 = parseInt(t.div11r1);
        b.reviewItem11.radioSelect2 = parseInt(t.div11r2);
        b.reviewItem11.fileObj1.filePath = t.div11F1;
        b.reviewItem11.fileObj2.filePath = t.div11F2;
        b.reviewItem11.remark = t.div11t1;

        b.reviewItem12.radioSelect = parseInt(t.div12r1);
        b.reviewItem12.selectedOptions = this.deToxicateArr(t.div12r2);
        b.reviewItem12.selectedOptions = b.reviewItem12.selectedOptions.filter(
          (item) => {
            if (item != 0) {
              return true;
            }
          }
        );

        b.reviewItem12.fileObj1.filePath = t.div12F1;
        b.reviewItem12.fileObj2.filePath = t.div12F2;
        b.reviewItem12.fileObj3.filePath = t.div12F3;
        // b.reviewItem12.fileObj4.filePath = t.div12F4;
        // b.reviewItem12.fileObj5.filePath = t.div12F5;
        b.reviewItem12.remark = t.div12t1;

        b.reviewItem13.radioSelect = this.radioNumToBoo(t.div13r1);
        b.reviewItem13.selectedOptions = this.deToxicateArr(t.div13r2);
        b.reviewItem13.fileObj1.filePath = t.div13F1;
        b.reviewItem13.fileObj2.filePath = t.div13F2;
        b.reviewItem13.fileObj3.filePath = t.div13F3;
        b.reviewItem13.remark = t.div13t1;

        b.reviewItem14.radioSelect = parseInt(t.div14r1);
        b.reviewItem14.fileObj.filePath = t.div14F1;
        b.reviewItem14.remark = t.div14t1;

        b.reviewItem15.radioSelect = parseInt(t.div15r1);
        b.reviewItem15.fileObj.filePath = t.div15F1;
        b.reviewItem15.remark = t.div15t1;

        b.reviewItem16.radioSelect = parseInt(t.div16r1);
        b.reviewItem16.counter1 = t.div16n1;
        b.reviewItem16.counter2 = t.div16n2;
        b.reviewItem16.counter3 = t.div16n3;
        b.reviewItem16.fileObj.filePath = t.div16F1;
        b.reviewItem16.remark = t.div16t1;

        b.reviewItem17.radioSelect = parseInt(t.div17r1);
        b.reviewItem17.counter = t.div17n1;
        b.reviewItem17.fileObj.filePath = t.div17F1;
        b.reviewItem17.remark = t.div17t1;

        b.reviewItem18.radioSelect = parseInt(t.div18r1);
        b.reviewItem18.fileObj.filePath = t.div18F1;
        b.reviewItem18.remark = t.div18t1;

        b.reviewItem19.radioSelect = parseInt(t.div19r1);
        b.reviewItem19.fileObj.filePath = t.div19F1;
        b.reviewItem19.remark = t.div19t1;

        b.reviewItem20.radioSelect = parseInt(t.div20r1);
        b.reviewItem20.fileObj.filePath = t.div20F1;
        b.reviewItem20.remark = t.div20t1;

        b.reviewItem21.radioSelect = parseInt(t.div21r1);
        b.reviewItem21.fileObj.filePath = t.div21F1;
        b.reviewItem21.remark = t.div21t1;

        b.reviewItem22.radioSelect = parseInt(t.div22r1);
        b.reviewItem22.fileObj.filePath = t.div22F1;
        b.reviewItem22.remark = t.div22t1;

        b.reviewItem23.radioSelect = parseInt(t.div23r1);
        b.reviewItem23.fileObj.filePath = t.div23F1;
        b.reviewItem23.remark = t.div23t1;

        b.reviewItem24.radioSelect = parseInt(t.div24r1);
        b.reviewItem24.fileObj.filePath = t.div24F1;
        b.reviewItem24.remark = t.div24t1;

        b.reviewItem25.selectedOptions = this.deToxicateArr(t.div25r1);
        b.reviewItem25.fileObj.filePath = t.div25F1;
        b.reviewItem25.remark = t.div25t1;
        //  分数赋值
        b.reviewItem1.score = t.score1;
        b.reviewItem2.score = t.score2;
        b.reviewItem3.score = t.score3;
        b.reviewItem4.score = t.score4;
        b.reviewItem5.score = t.score5;
        b.reviewItem6.score = t.score6;
        b.reviewItem7.score = t.score7;
        b.reviewItem8.score = t.score8;
        b.reviewItem9.score = t.score9;
        b.reviewItem10.score = t.score10;
        b.reviewItem11.score = t.score11;
        b.reviewItem12.score = t.score12;
        b.reviewItem13.score = t.score13;
        b.reviewItem14.score = t.score14;
        b.reviewItem15.score = t.score15;
        b.reviewItem16.score = t.score16;
        b.reviewItem17.score = t.score17;
        b.reviewItem18.score = t.score18;
        b.reviewItem19.score = t.score19;
        b.reviewItem20.score = t.score20;
        b.reviewItem21.score = t.score21;
        b.reviewItem22.score = t.score22;
        b.reviewItem23.score = t.score23;
        b.reviewItem24.score = t.score24;
        b.reviewItem25.score = t.score25;
      }
    },
    radioNumToBoo(num) {
      if (num == 1) {
        return true;
      } else {
        return false;
      }
    },
    async getGZReviewAuditList() {
      const { data } = await api.auditionApi.getAudItemList();
      // console.log(data)
      this.indexSelectList = [];
      data.resultObj.forEach((item) => {
        this.indexSelectList.push({
          value: item.id,
          label: item.name,
          no: item.no,
        });
      });
    },
    async getAuditItem(e) {
      this.indexSelectItemList = [];
      this.checkList = [];
      const { data } = await api.auditionApi.getAudSubItemList({
        headId: e.value,
        page: 1,
        rows: 99,
        order: "asc",
        sort: "id",
        value: "",
        regionId: 0,
      });
      data.resultObj.data.forEach((item) => {
        this.indexSelectItemList.push({
          value: item.id,
          label: item.name,
          score: item.score,
        });
      });
      this.radioSelect2 = "";
    },

    async saveVerifyStep() {
      const radioSelect = this.radioSelect;

      // if (radioSelect == 1) {
      //   score = this.radioSelect.score;
      // } else if (radioSelect == -1) {
      //    score = -this.radioSelect.score;
      // }
      const remark = this.verifyRemark;
      const auditsId = this.indexSelect.value;
      const auditsNo = this.indexSelect.no;
      const unitAppraiseComStepId = parseInt(this.unitAppraiseComStepId);
      const itemTitle = this.indexSelect.label;
      const fileUrl = this.fileUrl[0] || '';

      let auditsItemIds = "";
      let auditsItemNames = "";
      let score = 0
      for (let i in this.checkList) {
        if (this.checkList[i].value && this.checkList[i].label) {

          score += this.checkList[i].score
          auditsItemIds += this.checkList[i].value + ",";
          auditsItemNames += this.checkList[i].label + ",";
        }
      }
      if (radioSelect == -1) {
        score = -score;
      }
      const { data } = await api.auditionApi.saveVerifyList(
        radioSelect,
        unitAppraiseComStepId,
        score,
        remark,
        auditsId,
        auditsItemIds,
        auditsItemNames,
        auditsNo,
        itemTitle,
        fileUrl
      );
      if (data.resultMsg) {
        this.verifyRemark = "";
        this.$refs["my-upload"].clearFiles();
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
      } else {
        this.$message.error(data.resultMsg || "[保存审核项]未知错误");
      }
      this.getVerifyList();
    },
    async handleUpload(param) {
      // console.log(param.file.name)
      // let fileObj = document.getElementsByName('file')[0].files[0];
      let fileObj = param.file;
      console.log(fileObj)
      let formData = new FormData();
      formData.append("file", fileObj);
      const fileName = fileObj.name.substring(0, fileObj.name.lastIndexOf("."))
      const uappcomid = this.uappcomid;
      const uappcomappid = this.uappcomappid;
      // console.log(uappcomid, uappcomappid)
      const { data } = await api.reviewTaskApi.saveFile({
        uappcomid,
        seqnum: uappcomappid,
        formData,
        fileName,
        file: fileObj,
      });
      if (data.isSuccessful) {
        this.fileUrl = data.resultObj;
        this.fileList = [fileObj]
        this.$message({
          message: "附件上传成功，请点击保存完成修改",
          type: "success",
        });
      } else {
        this.$message.error(data.resultMsg);
        // param = ''
      }
    },
    async handleUploadCheck(e) {
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      const seqnum = e.srcElement.attributes.senum.value;
      const objName = e.srcElement.attributes.objName.value;
      const filePathKey = e.srcElement.attributes.filePathKey.value;
      const fileObj = e.target.files[0]
      const fileName = fileObj.name.substring(0, fileObj.name.lastIndexOf("."))
      if (objName == "basicInfo") {
        const filePathKey2 = e.srcElement.attributes.filePathKey2.value;
        const file = e.target.files[0];
        const { data } = await api.reviewTaskApi.saveFile({
          uappcomid: this.companyID,
          seqnum,
          formData,
          fileName,
          file,
        });
        if (data.isSuccessful) {
          this.reviewSubmitDatas[objName][filePathKey][filePathKey2].filePath =
            data.resultObj[0];
          this.reviewSubmitDatas[objName][filePathKey][filePathKey2].fileName =
            this.getFileName(data.resultObj[0]);
        } else {
          ElMessage({
            message: data.resultMsg || "未知错误，请联系管理员",
            type: "error",
          });
        }
      } else if (objName == "promiseLetter") {
        const file = e.target.files[0];
        const { data } = await api.reviewTaskApi.saveFile({
          uappcomid: this.companyID,
          seqnum,
          formData,
          fileName,
          file,
        });
        if (data.isSuccessful) {
          this.reviewSubmitDatas.promiseLetter = data.resultObj[0];
        } else {
          ElMessage({
            message: data.resultMsg || "未知错误，请联系管理员",
            type: "error",
          });
        }
      } else {
        const file = e.target.files[0];
        const { data } = await api.reviewTaskApi.saveFile({
          uappcomid: this.companyID,
          seqnum,
          formData,
          fileName,
          file,
        });
        if (data.isSuccessful) {
          this.reviewSubmitDatas[objName][filePathKey].filePath =
            data.resultObj[0];

          this.reviewSubmitDatas[objName][filePathKey].fileName =
            this.getFileName(data.resultObj[0]);
        } else {
          ElMessage({
            message: data.resultMsg || "未知错误，请联系管理员",
            type: "error",
          });
        }
      }
    },
    async saveData({ path, itemPath }) {
      const obj = this.reviewSubmitDatas[itemPath];
      this.hasFile = false;
      const keys = Object.keys(obj);
      if (itemPath == "promiseLetter") {
      } else if (itemPath == "danWeiZhengMing") {
      } else {
        let hasFileArr = [];
        keys.forEach((item) => {
          if (item.includes("fileObj")) {
            if (!obj[item].filePath == "") {
              console.info(obj[item], true);
              this.hasFile = true;
              hasFileArr.push(true);
            } else {
              console.info(obj[item], false);
              this.hasFile = false;
              hasFileArr.push(false);
            }
          }
        });
        console.info("hasFileArr", hasFileArr);
        this.hasFile = hasFileArr.every((item) => {
          console.info(item);
          return item == true;
        });
      }
      console.info("hasFileArr2", this.hasFile);

      let paraObj = {};
      let dataObj = {};
      let withData = false;
      switch (itemPath) {
        case "yiPiaoFouJue":
          let num = 0;
          if (!obj.isNotOnePollOut) {
            num = 1;
          } else {
            num = 0;
          }
          const ax = obj.onePollOutList;
          let cx = [];
          ax.forEach((item) => {
            if (typeof item === "number") {
              console.info(item == NaN);
              cx.push(item);
            }
          });

          let arrWithOutNaN = [];
          cx.forEach((item) => {
            if (item === item) {
              arrWithOutNaN.push(item);
            }
          });

          paraObj = {
            divv3r1: num,
            divv3r2: arrWithOutNaN.toString() || "",
            divv3F2: obj.fileObj.filePath || "",
          };
          if (!paraObj.divv3r1) {
            hasFile = true;
          }
          break;
        case "reviewItem1":
          paraObj = {
            div1t1: obj.remark || "",
            div1r1: this.radioFilter(
              obj.radioSelect1,
              obj,
              "reviewItem1div1r1"
            ),
            div1r2: obj.selectedOptions.toString(),
            div1r3: obj.radioSelect2,
            div1F1: obj.fileObj1.filePath || "",
            div1F2: obj.fileObj2.filePath || "",
            div1F3: obj.fileObj3.filePath || "",
            div1F4: obj.fileObj4.filePath || "",
            div1F5: obj.fileObj5.filePath || "",
          };

          if (paraObj.div1r1 && paraObj.div1F1) {
            paraObj.div1r2 = 0;
            this.hasFile = true;
          }
          const reviewItem1Keys = Object.keys(paraObj);
          let neededFilesArr = [];
          console.info("div1r2", paraObj.div1r2);
          if (paraObj.div1r2 && paraObj.div1r2.includes("1")) {
            reviewItem1Keys.forEach((item, index) => {
              if (item.includes("div1F")) {
                console.info(paraObj[item]);
                if (paraObj[item]) {
                  neededFilesArr.push(index);
                }
              }
            });
            const filesShouldHaveArr = [5, 6, 7, 8];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr.includes(i)
            );
            this.hasFile = containsAll;
          } else if (
            obj.selectedOptions.length &&
            !obj.selectedOptions.includes("1")
          ) {
            reviewItem1Keys.forEach((item, index) => {
              if (item.includes("div1F")) {
                console.info(paraObj[item]);
                if (paraObj[item]) {
                  neededFilesArr.push(index);
                }
              }
            });
            const filesShouldHaveArr = [5, 6, 7, 8];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr.includes(i)
            );
            this.hasFile = containsAll;
          } else if (paraObj.div1r1 == 1) {
            console.info("elseeee ifffff");
            reviewItem1Keys.forEach((item, index) => {
              console.info(index, "itemsss", item);
              if (item.includes("div1F")) {
                if (paraObj[item]) {
                  neededFilesArr.push(index);
                }
              }
            });
            const filesShouldHaveArr = [4];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr.includes(i)
            );
            this.hasFile = containsAll;
          } else {
            console.warn("elsesss");
            reviewItem1Keys.forEach((item) => {
              if (item.includes("div1F")) {
                if (paraObj[item] == "") {
                  this.hasFile = false;
                }
              }
            });
          }
          break;
        case "reviewItem2":
          paraObj = {
            div2t1: obj.remark || "",
            div2r1: obj.radioSelect,
            div2F1: obj.fileObj.filePath || "",
            div2F2: "",
          };
          break;
        case "reviewItem3":
          paraObj = {
            div3t1: obj.remark || "",
            div3r1: this.radioFilter(obj.radioSelect1, obj),
            div3r2: obj.radioSelect2,
            div3r3: obj.radioSelect3,
            div3F1: obj.fileObj1.filePath || "",
            div3F2: obj.fileObj2.filePath || "",
            div3F3: obj.fileObj3.filePath || "",
          };
          const reviewItem3Keys = Object.keys(paraObj);
          let neededFilesArr2 = [];
          if (paraObj.div3r1 == 0) {
            reviewItem3Keys.forEach((item, index) => {
              if (item.includes("div3F")) {
                //  console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr2.push(index);
                }
              }
            });
            const filesShouldHaveArr = [5, 6];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr2.includes(i)
            );
            this.hasFile = containsAll;
          } else {
            reviewItem3Keys.forEach((item, index) => {
              if (item.includes("div3F")) {
                //  console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr2.push(index);
                }
              }
            });
            const filesShouldHaveArr = [4];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr2.includes(i)
            );
            this.hasFile = containsAll;
          }
          break;
        case "reviewItem4":
          paraObj = {
            div4t1: obj.remark || "",
            div4r1: this.radioFilter(obj.radioSelect1, obj),
            div4r2: obj.radioSelect2,
            div4r3: obj.radioSelect3,
            div4F1: obj.fileObj1.filePath || "",
            div4F2: obj.fileObj2.filePath || "",
          };
          const reviewItem4Keys = Object.keys(paraObj);
          let neededFilesArr3 = [];
          if (obj.radioSelect1) {
            reviewItem4Keys.forEach((item, index) => {
              if (item.includes("div4F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr3.push(index);
                }
              }
            });
            const filesShouldHaveArr = [4];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr3.includes(i)
            );
            paraObj.div4F2 = "";
            this.hasFile = containsAll;
          } else {
            reviewItem4Keys.forEach((item, index) => {
              if (item.includes("div4F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr3.push(index);
                }
              }
            });
            const filesShouldHaveArr = [4, 5];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr3.includes(i)
            );
            this.hasFile = containsAll;
          }

          break;
        case "reviewItem5":
          paraObj = {
            div5t1: obj.remark || "",
            div5r1: this.radioFilter(
              obj.radioSelect1,
              obj,
              "reviewItem5div5r1"
            ),
            div5r2: obj.radioSelect2,
            div5r3: obj.selectedOptions.toString(),
            div5r4: this.radioFilter(
              obj.radioSelect3,
              obj,
              "reviewItem5div5r4"
            ),
            div5r5: obj.radioSelect4,
            div5F1: obj.fileObj1.filePath || "",
            div5F2: obj.fileObj2.filePath || "",
            div5F3: obj.fileObj3.filePath || "",
            div5F4: obj.fileObj4.filePath || "",
          };
          if (paraObj.div5r1) {
            paraObj.div5r5 = 0;
          }
          if (paraObj.div5r5 == 1) {
            paraObj.div5r2 = 0;
          } else {
            paraObj.div5r3 = 0;
          }
          const reviewItem5Keys = Object.keys(paraObj);
          let neededFilesArr4 = [];
          if (obj.radioSelect1 || obj.radioSelect3) {
            reviewItem5Keys.forEach((item, index) => {
              if (item.includes("div5F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr4.push(index);
                }
              }
            });
            const filesShouldHaveArr = [6];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr4.includes(i)
            );
            paraObj.div4F2 = "";
            this.hasFile = containsAll;
          } else if (obj.radioSelect4 == 0) {
            reviewItem5Keys.forEach((item, index) => {
              if (item.includes("div5F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr4.push(index);
                }
              }
            });
            const filesShouldHaveArr = [6];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr4.includes(i)
            );
            paraObj.div4F2 = "";
            this.hasFile = containsAll;
          } else {
            reviewItem5Keys.forEach((item, index) => {
              if (item.includes("div5F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr4.push(index);
                }
              }
            });
            const filesShouldHaveArr = [6, 7, 8];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr4.includes(i)
            );
            this.hasFile = containsAll;
          }
          break;
        case "reviewItem6":
          paraObj = {
            div6t1: obj.remark || "",
            div6r1: obj.radioSelect,
            div6F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem7":
          paraObj = {
            div7t1: obj.remark || "",
            div7r1: obj.radioSelect1,
            div7r2: this.radioFilter(
              obj.radioSelect2,
              obj,
              "reviewItem7div7r2"
            ),
            div7r3: this.radioFilter(
              obj.radioSelect3,
              obj,
              "reviewItem7div7r3"
            ),
            div7F1: obj.fileObj1.filePath || "",
            div7F2: obj.fileObj2.filePath || "",
          };
          if (paraObj.div7r3) {
            paraObj.div7r1 = 0;
            paraObj.div7r2 = 0;
          }
          const reviewItem7Keys = Object.keys(paraObj);
          let neededFilesArr7 = [];
          const condition = obj.radioSelect1 != 0 && !obj.radioSelect2;
          if (condition || obj.radioSelect3) {
            reviewItem7Keys.forEach((item, index) => {
              if (item.includes("div7F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr7.push(index);
                }
              }
            });
            const filesShouldHaveArr = [4];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr7.includes(i)
            );
            paraObj.div4F2 = "";
            this.hasFile = containsAll;
          } else {
            reviewItem7Keys.forEach((item, index) => {
              if (item.includes("div7F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr7.push(index);
                }
              }
            });
            const filesShouldHaveArr = [4, 5];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr7.includes(i)
            );
            this.hasFile = containsAll;
          }

          break;
        case "reviewItem8":
          paraObj = {
            div8t1: obj.remark || "",
            div8r1: obj.radioSelect,
            div8F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem9":
          paraObj = {
            div9t1: obj.remark || "",
            div9r1: obj.radioSelect,
            div9F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem10":
          paraObj = {
            div10t1: obj.remark || "",
            div10r1: obj.radioSelect,
            div10F1: obj.fileObj.filePath || "",
          };
          break;

        case "reviewItem11":
          paraObj = {
            div11t1: obj.remark || "",
            div11r1: obj.radioSelect1,
            div11r2: obj.radioSelect2,
            div11F1: obj.fileObj1.filePath || "",
            div11F2: obj.fileObj2.filePath || "",
          };
          break;
        case "reviewItem12":
          paraObj = {
            div12t1: obj.remark || "",
            div12r1: obj.radioSelect,
            div12r2: obj.selectedOptions.toString(),
            div12F1: obj.fileObj1.filePath || "",
            div12F2: obj.fileObj2.filePath || "",
            div12F3: obj.fileObj3.filePath || "",
            div12F4: "",
            div12F5: "",
          };
          const reviewItem12Keys = Object.keys(paraObj);
          let neededFilesArr12 = [];
          if (obj.radioSelect && obj.selectedOptions.length < 1) {
            reviewItem12Keys.forEach((item, index) => {
              if (item.includes("div12F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr12.push(index);
                }
              }
            });
            const filesShouldHaveArr = [3];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr12.includes(i)
            );
            paraObj.div4F2 = "";
            this.hasFile = containsAll;
          } else {
            reviewItem12Keys.forEach((item, index) => {
              if (item.includes("div12F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr12.push(index);
                }
              }
            });
            const filesShouldHaveArr = [3, 4, 5];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr12.includes(i)
            );
            this.hasFile = containsAll;
          }

          break;
        case "reviewItem13":
          paraObj = {
            div13t1: obj.remark || "",
            div13r1: this.radioFilter(
              obj.radioSelect,
              obj,
              "reviewItem13div13r1"
            ),
            div13r2: obj.selectedOptions.toString(),
            div13F1: obj.fileObj1.filePath || "",
            div13F2: obj.fileObj2.filePath || "",
            div13F3: obj.fileObj3.filePath || "",
          };
          const reviewItem13Keys = Object.keys(paraObj);
          let neededFilesArr13 = [];
          if (obj.radioSelect && obj.selectedOptions.length < 1) {
            reviewItem13Keys.forEach((item, index) => {
              if (item.includes("div13F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr13.push(index);
                }
              }
            });
            const filesShouldHaveArr = [3];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr13.includes(i)
            );
            paraObj.div4F2 = "";
            this.hasFile = containsAll;
          } else {
            reviewItem13Keys.forEach((item, index) => {
              if (item.includes("div13F")) {
                console.info(item, index);
                if (paraObj[item]) {
                  neededFilesArr13.push(index);
                }
              }
            });
            const filesShouldHaveArr = [3, 4, 5];
            let containsAll = filesShouldHaveArr.every((i) =>
              neededFilesArr13.includes(i)
            );
            this.hasFile = containsAll;
          }

          break;
        case "reviewItem14":
          paraObj = {
            div14t1: obj.remark || "",
            div14r1: obj.radioSelect,
            div14F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem15":
          paraObj = {
            div15t1: obj.remark || "",
            div15r1: obj.radioSelect,
            div15F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem16":
          paraObj = {
            div16t1: obj.remark || "",
            div16r1: obj.radioSelect,
            div16n1: obj.counter1,
            div16n2: obj.counter2,
            div16n3: obj.counter3,
            div16F1: obj.fileObj.filePath || "",
          };
          if (obj.radioSelect == 3) {
            paraObj.div16n1 = 0;
            paraObj.div16n2 = 0;
            paraObj.div16n3 = 0;
          }
          console.info("div16", paraObj);
          break;
        case "reviewItem17":
          paraObj = {
            div17t1: obj.remark || "",
            div17r1: obj.radioSelect,
            div17n1: obj.counter,
            div17F1: obj.fileObj.filePath || "",
          };
          if (obj.radioSelect == 2 || obj.radioSelect == 1) {
            paraObj.div17n1 = 0;
          }
          break;
        case "reviewItem18":
          paraObj = {
            div18t1: obj.remark || "",
            div18r1: obj.radioSelect,
            div18F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem19":
          paraObj = {
            div19t1: obj.remark || "",
            div19r1: obj.radioSelect,
            div19F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem20":
          paraObj = {
            div20t1: obj.remark || "",
            div20r1: obj.radioSelect,
            div20F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem21":
          paraObj = {
            div21t1: obj.remark || "",
            div21r1: obj.radioSelect,
            div21F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem22":
          paraObj = {
            div22t1: obj.remark || "",
            div22r1: obj.radioSelect,
            div22F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem23":
          paraObj = {
            div23t1: obj.remark || "",
            div23r1: obj.radioSelect,
            div23F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem24":
          paraObj = {
            div24t1: obj.remark || "",
            div24r1: obj.radioSelect,
            div24F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem25":
          paraObj = {
            div25t1: obj.remark || "",
            div25r1: obj.selectedOptions.toString() || "0",
            div25F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem26":
          paraObj = {
            div27t1: obj.remark || "",
            div27r1: obj.radioSelect,
            div27F1: obj.fileObj.filePath || "",
          };
          break;
        case "reviewItem27":
          paraObj = {
            div28t1: obj.remark || "",
            div28r1: obj.radioSelect,
            div28F1: obj.fileObj.filePath || "",
          };
      }
      console.info("hasFileeeee", this.hasFile);
      if (withData && this.hasFile) {
        const { data } = await api.reviewTaskApi.submitReviewItemWithData(
          this.reviewProjectID,
          path,
          paraObj,
          dataObj
        );
        if (data.isSuccessful) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
        } else {
          if (data.resultMsg) {
            this.$message({
              message: data.resultMsg,
              type: "error",
            });
          } else {
            this.$message({
              message: "发生未知错误，请联系管理员",
              type: "error",
            });
          }
        }
        if (data.ResultData) {
          this.reviewSubmitDatas[itemPath].score = data.ResultData;
        }
      } else if (this.hasFile) {
        const { data } = await api.reviewTaskApi.submitReviewItem(
          this.reviewProjectID,
          path,
          paraObj
        );
        if (data.isSuccessful) {
          this.$message({
            message: "保存成功",
            type: "success",
          });

          this.updateScore();
        } else {
          if (data.resultMsg) {
            this.$message({
              message: data.resultMsg,
              type: "error",
            });
          } else {
            this.$message({
              message: "发生未知错误，请联系管理员",
              type: "error",
            });
          }
        }
        if (data.ResultData) {
          this.reviewSubmitDatas[itemPath].score = data.ResultData;
        }
      } else {
        alert("请上传附件！");
      }
      this.getBackUp();
    },
    async updateScore() {
      const res = await api.guiZhouReviewApi.getReviewProject(this.uCompanyId);
      // console.info("score1", res.data.resultObj.appraiseCompany.score1);
      // this.currentScore = res.data.resultObj.appraiseCompany.score1;
    },
    // async uploadReport() {
    // 	const UnitAppraiseId = this.reviewDatas.UnitAppraiseId
    // 	const BaseCompanyId = this.reviewDatas.BaseCompanyId
    // 	const TEnvironmentUnitAppraiseCompanyId = this.reviewDatas.id
    // 	const CreatorId = parseInt(localStorage.getItem('zjyMirror_Ids'))
    // 	const regionName = this.reviewDatas.RegionFullName
    // 	// const FileUrl = this.reviewDatas.baseCompanyId
    // 	let result1 = regionName.indexOf("重庆");

    // 	var myDate = new Date();
    // 	if (result1 != -1) {
    // 		var Code = 'CQ' + (myDate.getFullYear() - 1) + 'HJ' + this.reviewDatas.id
    // 	} else {
    // 		let result1 = regionName.indexOf("贵州");
    // 		var Code = 'GZ' + (myDate.getFullYear() - 1) + 'HJ' + this.reviewDatas.id
    // 	}

    // 	// console.log(UnitAppraiseId, BaseCompanyId, TEnvironmentUnitAppraiseCompanyId, CreatorId, Code)
    // 	const {
    // 		data
    // 	} = await api.reviewApi.saveReport({
    // 		UnitAppraiseId: UnitAppraiseId,
    // 		BaseCompanyId: BaseCompanyId,
    // 		TEnvironmentUnitAppraiseCompanyId: TEnvironmentUnitAppraiseCompanyId,
    // 		// CreatorId:CreatorId,
    // 		// CreateTime:'',
    // 		Code: Code,
    // 		FileUrl: this.reportFileUrl,
    // 	});
    // 	if (data.isSuccessful) {
    // 		this.reportVisible = false
    // 		// console.log(data)
    // 		this.$message({
    // 			message: data.resultMsg,
    // 			type: 'success'
    // 		});
    // 	} else {
    // 		this.$message.error(data.resultMsg)
    // 	}

    // },
    // async checkReport() {
    // 	const TEnvironmentUnitAppraiseCompanyId = this.reviewDatas.id
    // 	const {
    // 		data
    // 	} = await api.reviewApi.checkReport({
    // 		unitAppraiseComId: TEnvironmentUnitAppraiseCompanyId
    // 	})
    // 	if (data.isSuccessful) {
    // 		// console.log(data)
    // 		this.reportDatas = data.resultObj
    // 		// console.log(this.reportDatas)
    // 		if (this.reportDatas) {
    // 			this.href11 = 'http://221.10.90.140:8082' + this.reportDatas.FileUrl
    // 		}
    // 		// console.log(this.href11)
    // 		// console.log(data)
    // 	}
    // },
    // async handleUploadReport(param) {

    // 	// console.log(param)
    // 	let fileObj = param.file;
    // 	console.log(fileObj)
    // 	let formData = new FormData();
    // 	// console.log(this.reviewDatas)
    // 	let uappcomid = this.reviewDatas.id
    // 	// console.log(uappcomid)
    // 	formData.append('file', fileObj);
    // 	// console.log(uappcomid, uappcomappid)
    // 	const {
    // 		data
    // 	} = await api.reviewApi.saveReportFile({
    // 		uappcomid,
    // 		formData
    // 	})
    // 	if (data.isSuccessful) {
    // 		console.log(data.resultObj)
    // 		this.reportFileUrl = data.resultObj
    // 		this.$message({
    // 			message: data.resultMsg,
    // 			type: 'success'
    // 		});
    // 	} else {
    // 		this.$message.error(data.resultMsg);
    // 		param = ''
    // 	}
    // 	// console.log(data)
    // },
    handleClick(tab, event) {
      // console.log(tab.index);
      this.tabListNum = tab.index - 1;

    },
    handleClick2(tab, event) {

      this.tabListNum = tab.index - 1;
      this.getVerifyList();
    },
    async getVerifyList() {
      this.tableData2 = {};
      const { data } = await api.auditionApi.getAudHistory(this.uCompanyId);
      this.stepList = data.resultObj;

      if (data.resultObj.length > 1) {
        this.stepList.pop();
      }
      if (!this.tabListNum) {
        this.tabs = data.resultObj[0].step.flowStepname;
      }
      // this.stepList = this.stepList.filter((item) => item.flowStepname!= '参评企业填报' );
      // this.stepList = this.stepList.filter((item) => item.flowStepname!= '信用信息采集' );

      // sessionStorage.setItem('BB', data.resultObj[0].step.id)
      this.unitAppraiseComStepId = data.resultObj[0].step.id;

      this.uappcomid = data.resultObj[0].step.unitAppraiseComId;

      this.uappcomappid = data.resultObj[0].step.id;
      console.info("x", this.tabListNum, "xx", data.resultObj[this.tabListNum])
      this.tableData2 = data.resultObj[this.tabListNum].items;

      this.reviewDatas.flowStepname =
        data.resultObj[this.tabListNum].step.flowStepname;
    },
    async deleteVerifyStep(scope) {
      const { data } = await api.auditionApi.deleteVerifyStep(scope.id);
      if (data.isSuccessful) {
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
        this.getVerifyList();
      } else {
        this.$message.error(data.resultMsg);
      }

      // console.log(scope)
    },
    async finishVerify() {
      const { data } = await api.auditionApi.finishVerifyStep(this.uCompanyId);
      // console.log(data)
      if (data.isSuccessful) {
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
      } else {
        this.$message.error("操作失败");
      }
    },
    async checkInfo() {
      this.dialogVisible = true;
    },
    async generateReport() {
      const { href } = this.$router.resolve({
        path: "/system/reviewForm/creditReport",
        query: {
          appid: this.reviewDatas.id,
        },
      });
      window.open(href, "_blank");
    },

    handleSelectionChange(data) {
      // this.multipleSelection = [];
      this.multipleSelection = data;
      console.log('multiple select', data)
      // this.multipleSelection.push(data.resultObj)
      // console.log(this.multipleSelection)
      // data.forEach((item) => {
      //   this.multipleSelection.push({
      //     Id: item.id,
      //   });
      // });
      // console.log(this.multipleSelection)
    },

    async deleteVerifySteps() {
      for (let i = 0; i < this.multipleSelection.length; i++) {
        // console.log(this.multipleSelection[i])
        const { data } = await api.auditionApi.deleteVerifyStep(
          this.multipleSelection[i].id
        );
        if (data.isSuccessful) {
          this.$message({
            message: data.resultMsg,
            type: "success",
          });
        } else {
          this.$message.error(data.resultMsg);
        }
      }
      this.getVerifyList();
    },
    exportExcel() {
      /* generate workbook object from table */
      //表名
      var wb = XLSX.utils.table_to_book(document.querySelector(".table_v"));
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream",
          }),
          "审核表格.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    handleChangeWindow() {
      // this.main_width = '0%';
      // this.aside_width = '100%'
    },
    getFileName(val) {
      if (val != null) {
        if (val || val != "") {
          const fileUrl = val.split("/");
          const fileName = fileUrl.pop();
          return fileName;
        } else {
          const str = "无";
          return str;
        }
      }
    },

    deToxicateArr(arr) {
      if (arr) {
        const x = arr.split(",");
        let newArr = [];
        x.forEach((item) => {
          const t = parseInt(item);
          if (t === t) {
            newArr.push(t.toString());
          }
        });
        return newArr;
      } else {
        return [0];
      }
    },
    dateTrimmer(str) {
      if (str) {
        return str.split("T")[0];
      } else {
        return "无";
      }
    },
    timeTrimmer(str) {
      if (str) {
        return str.split("T")[1];
      } else {
        return "无";
      }
    },
    levelSort(score) {
      if (score < 0 || score > 100) {
        return "无效分数";
      }
      if (score >= 90 && score < 96) {
        return "A";
      }
      if (score >= 96 && score < 100) {
        return "A+";
      }
      if (score == 100) {
        return "A++";
      }
      if (score >= 75 && score < 80) {
        return "B";
      }
      if (score >= 80 && score < 86) {
        return "B+";
      }
      if (score >= 86 && score < 90) {
        return "B++";
      }
      if (score >= 60 && score < 66) {
        return "C";
      }
      if (score >= 66 && score < 71) {
        return "C+";
      }
      if (score >= 71 && score < 75) {
        return "C++";
      }
      return "D";
    },

    //申诉
    handleOpenFile(val) {
      // 打开附件
      let url = val.AppealFileUrl;
      // window.open(`http://xn--ruqw0vu2ty8bxz1e.com${url}`)
      window.open(`${this.BASE_URL}${url}`);
    },
    handleChange(index) {
      // 下拉选择框
      this.form.AudsId = this.options[index].id;
      this.form.name = this.options[index].name;
    },
    handleSizeChange(val) {
      // console.log(val)
      this.params.rows = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.handleQuery();
    },
    async handleQuery() {
      // 获取表格列表
      const { data } = await api.auditionApi.getAppealHistory(this.params);
      if (data.isSuccessful) {
        this.tableData222 = data.resultObj.data || [];
        // this.tableTotal = data.resultObj.PagerInfo.totalRowCount;
        console.info("tabledata222", data.resultObj.data);
        this.pageInfo = data.resultObj.pagerInfo;
      } else {
        this.$message({
          message: data.resultMsg,
          type: "error",
        });
      }
    },
    async dealAppeal(id) {
      const { data } = await api.auditionApi.dealAppealItem(id)
      if (data.isSuccessful) {
        this.$message({
          message: '操作成功',
          type: "success",
        });
        this.handleQuery()
      } else {
        this.$message({
          message: data.resultMsg || "[标记申诉项]未知错误，请联系管理员",
          type: "error",
        });
      }

    },
    handlePrev() {
      // 上一页
      this.params.page--;
      this.handleQuery();
    },
    handleNext() {
      // 下一页
      this.params.page++;
      this.handleQuery();
    },
    handleCurrent(index) {
      // 改变时会触发当前页
      this.params.page = index;
      this.handleQuery();
    },
    handleBack() {
      // 返回上一步
      this.$router.back();
    },
  },
};
</script>

<style lang="sass" scoped>
@use "../../assets/scss/auditionSubmit.scss" as *
</style>
